"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3838,3282],{

/***/ 3282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2595);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);







const BreadCrumb = (props)=>{
    const { data: { appliedCssClassNames ="" , items =[]  } , fullData ={}  } = props;
    const { carousel: { carouselComponentProperties: { appliedCssClassNames: carouselClassName = ""  } = {}  } = {}  } = fullData;
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const [eventPageName, setEventPageName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [shortURLs, setShortURLs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [componentGroup, setComponentGroup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const urls = items.map((navItem)=>navItem.url);
        Promise.all(urls.map(_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Ppy)).then((res)=>setShortURLs(res));
    }, [
        items
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isSsr) return;
        setEventPageName(window.eventPageType);
    }, [
        isSsr
    ]);
    // #ToDo Hard coding zone value once received data from json will change
    const zone = "hero banner";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.TEASER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.CAROUSEL);
            }) && carouselClassName === "carousel-navigation-cta-left-right") {
                setColumnClassNames((className)=>className += " breadcrumb-overlay");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.CAROUSEL);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.CONTAINER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    const getEventInfo = (navItem, index)=>{
        if (isSsr) {
            return JSON.stringify({
                clickInternalLinks: "true",
                eventAction: eventPageName + ":" + zone + ":breadcrumb",
                eventName: eventPageName + ":" + zone + ":breadcrumb",
                eventType: eventPageName,
                internalLinkName: navItem === null || navItem === void 0 ? void 0 : navItem.title,
                internalLinkPosition: "main content area",
                internalLinkType: window.storeLinkType ? window.storeLinkType : eventPageName + ":breadcrumb",
                internalLinkURL: navItem === null || navItem === void 0 ? void 0 : navItem.url,
                internalLinkZoneName: eventPageName + ":" + zone
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "breadcrumb breadcrumb-links ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(columnClassNames),
            children: items.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                id: "breadcrumb",
                className: "cmp-breadcrumb",
                "aria-label": "Breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: "cmp-breadcrumb__list",
                    itemScope: true,
                    children: items.map((navItem, index)=>{
                        const isLastItem = index === items.length - 1;
                        const isActive = navItem.active;
                        const shouldRenderSlash = !isActive && !isLastItem && !items[index + 1].active;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "cmp-breadcrumb__item".concat(navItem.active ? " cmp-breadcrumb__item--active" : ""),
                            itemProp: "itemListElement",
                            itemScope: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: shortURLs[index],
                                    className: "cmp-breadcrumb__item-link",
                                    itemProp: "item",
                                    "data-zone": zone,
                                    "aria-label": navItem.title,
                                    "aria-current": navItem.active || isLastItem ? "page" : null,
                                    "data-gbh-data-layer": !isSsr && getEventInfo(navItem, index),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        itemProp: "name",
                                        dangerouslySetInnerHTML: {
                                            __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(navItem === null || navItem === void 0 ? void 0 : navItem.title)
                                        }
                                    })
                                }),
                                " ",
                                shouldRenderSlash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "cmp-breadcrumb-slash",
                                            "aria-hidden": "true"
                                        }),
                                        "\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    itemProp: "position",
                                    content: index + 1
                                })
                            ]
                        }, "breadcrumb-item-".concat(index));
                    })
                })
            }) : null
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);


/***/ }),

/***/ 89150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A3": function() { return /* binding */ addPrintOrShareAnalytics; },
/* harmony export */   "Db": function() { return /* binding */ getFilterAnalyticsForFacetCheckbox; },
/* harmony export */   "Iy": function() { return /* binding */ getAnalyticsDataForClearAll; },
/* harmony export */   "N4": function() { return /* binding */ getAnalyticsDataForFilterCloseOverlay; },
/* harmony export */   "ND": function() { return /* binding */ getShowHideFilterOptionAnalyticsData; },
/* harmony export */   "XN": function() { return /* binding */ getTrackingAttributesForSort; },
/* harmony export */   "l5": function() { return /* binding */ getTrackingAttributeForClearAllCTA; },
/* harmony export */   "mT": function() { return /* binding */ getAnalyticsDataForSocialShare; },
/* harmony export */   "mv": function() { return /* binding */ getAnalyticsDataForSortByClick; },
/* harmony export */   "og": function() { return /* binding */ getAnalyticsDataForViewAllResultsCTA; },
/* harmony export */   "ow": function() { return /* binding */ getFilterAnalyticsForTagClearCTA; },
/* harmony export */   "pc": function() { return /* binding */ addCollapseAnalytics; }
/* harmony export */ });
/* unused harmony export FILTER */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/**
 * Pushes analytics data for the "Clear All" filters action.
 * @return {void}
 */ 
const getAnalyticsDataForClearAll = ()=>{
    const eventInfo = {
        eventAction: "plp clear all filter",
        eventName: "plp clear all filter",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "clear all",
        internalLinkPosition: "plp",
        internalLinkType: "plp:clear all",
        internalLinkZoneName: "plp:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const pageEvent = window.pageObj || {};
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const updatedPageEvent = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: updatedPageEvent,
        eventInfo
    });
};
/**
 * Pushes analytics data for closing the filter overlay.
 * @return {void}
 */ const getAnalyticsDataForFilterCloseOverlay = ()=>{
    const pageEvent = window.pageObj || {};
    const eventInfo = {
        eventAction: "plp filter close",
        eventName: "plp filter close",
        eventType: "informative",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "close",
        internalLinkType: "plp:close",
        internalLinkZoneName: "plp:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const updatedPageEvent = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: updatedPageEvent,
        eventInfo
    });
};
/**
 * Pushes analytics data for the "View All Results" CTA.
 * @return {void}
 */ const getAnalyticsDataForViewAllResultsCTA = ()=>{
    const pageEvent = window.pageObj || {};
    const eventInfo = {
        eventAction: "plp filter view result",
        eventName: "plp filter view result",
        eventType: "informative",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view result",
        internalLinkPosition: "plp",
        internalLinkType: "plp:filters",
        internalLinkZoneName: "plp:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        filterArray: ""
    };
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const updatedPageEvent = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: updatedPageEvent,
        eventInfo
    });
};
/**
 * Pushes analytics data for social share actions.
 * @param {boolean} clickInternal
 * @param {string} name
 * @param {string} link
 * @param {string} share
 * @return {void}
 */ const getAnalyticsDataForSocialShare = (clickInternal, name, link, share)=>{
    const eventInfo = {
        eventAction: "plp share",
        eventName: "plp share",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(name),
        internalLinkPosition: "plp",
        internalLinkType: "plp:share",
        internalLinkZoneName: "plp:promo tiles",
        internalLinkURL: link,
        clickInternalLinks: "".concat(clickInternal)
    };
    if (share) {
        return {
            "data-datalayer-id": "kds-element-plp",
            "data-datalayer-data": JSON.stringify(eventInfo)
        };
    }
    const pageEvent = window.pageObj || {};
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const updatedPageEvent = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: updatedPageEvent,
        eventInfo
    });
};
/**
 * Pushes analytics data for showing or hiding filter options.
 * @param {boolean} showHide
 * @return {void}
 */ const getShowHideFilterOptionAnalyticsData = (showHide)=>{
    const state = showHide ? "show" : "hide";
    const pageEvent = window.pageObj || {};
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "plp:".concat(state, " filter"),
        eventName: "plp:".concat(state, " filter"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(state, " filters"),
        internalLinkType: "plp:".concat(state),
        internalLinkURL: "n/a",
        internalLinkPosition: "plp",
        internalLinkZoneName: "plp:filters"
    };
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const updatedPageEvent = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: updatedPageEvent,
        eventInfo
    });
};
/**
 * Pushes analytics data for sort by filter click.
 * @param {string} e
 * @return {void}
 */ const getAnalyticsDataForSortByClick = (e)=>{
    const pageEvent = window.pageObj || {};
    const eventInfo = {
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(e.toLocaleLowerCase()),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        eventAction: "plp sort by filter",
        eventName: "plp sort by filter",
        internalLinkPosition: "plp",
        internalLinkType: "plp:sort by",
        internalLinkZoneName: "plp:sort by filter"
    };
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const updatedPageEvent = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: updatedPageEvent,
        eventInfo
    });
};
/**
 * Pushes analytics data for facet checkbox filter.
 * @param {string} actionType - The type of filter action (e.g., "add", "remove").
 * @param {string} value - The value of the facet checkbox.
 * @param {string} facet - The name of the facet.
 * @param {Array} filterArray - The array of currently applied filters.
 * @return {void}
 */ const getFilterAnalyticsForFacetCheckbox = (actionType, value, facet, filterArray)=>{
    const eventData = {
        eventAction: "plp filter ".concat(actionType),
        eventName: "plp filter ".concat(actionType),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: value,
        internalLinkPosition: "plp",
        internalLinkType: "plp:".concat(facet ? facet.toLowerCase() : ""),
        internalLinkZoneName: "plp:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        filterArray: filterArray
    };
    const pageEvent = window.pageObj || {};
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const updatedPageEvent = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: updatedPageEvent,
        eventInfo: eventData
    });
};
/**
 * Pushes analytics data for print or share actions on the PLP.
 * @param {string} printOrShare - The action type, either "print" or "share".
 * @return {void}
 */ const addPrintOrShareAnalytics = (printOrShare)=>{
    const eventInfo = {
        eventAction: "plp ".concat(printOrShare),
        eventName: "plp ".concat(printOrShare),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: printOrShare,
        internalLinkPosition: "plp",
        internalLinkType: "plp:".concat(printOrShare),
        internalLinkZoneName: "plp:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const pageEvent = window.pageObj || {};
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const updatedPageEvent = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: updatedPageEvent,
        eventInfo
    });
};
const FILTER = {
    EXPAND: "expand",
    COLLAPSE: "collapse",
    FILTERS: "filters",
    HIDE_DISCONTINUED: "hide discontinued products"
};
/**
 * Pushes analytics data for expanding or collapsing a filter group on the PLP.
 * @param {boolean} collapseState - True if the filter group is expanded, false if collapsed.
 * @param {string} facetName - The name of the facet being expanded or collapsed.
 * @return {void}
 */ const addCollapseAnalytics = (collapseState, facetName)=>{
    const eventInfo = {
        eventAction: "plp filter ".concat(collapseState ? FILTER.EXPAND : FILTER.COLLAPSE),
        eventName: "plp filter ".concat(collapseState ? FILTER.EXPAND : FILTER.COLLAPSE),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: collapseState ? FILTER.EXPAND : FILTER.COLLAPSE,
        internalLinkPosition: "plp",
        internalLinkType: "plp:" + facetName.toLowerCase(),
        internalLinkZoneName: "plp:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const pageEvent = window.pageObj || {};
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const updatedPageEvent = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: updatedPageEvent,
        eventInfo
    });
};
const getTrackingAttributesForSort = (label)=>{
    return JSON.stringify({
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(label.toLowerCase()),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        eventAction: "plp sort by filter",
        eventName: "plp sort by filter",
        internalLinkPosition: "plp",
        internalLinkType: "plp:sort by",
        internalLinkZoneName: "plp:sort by filter"
    });
};
const getFilterAnalyticsForTagClearCTA = (filterArray, value, facet)=>{
    const eventData = {
        eventAction: "plp filter cancel",
        eventName: "plp filter cancel",
        eventType: "navigation",
        filterArray: filterArray,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: value,
        internalLinkPosition: "plp",
        internalLinkType: "plp:".concat(facet),
        internalLinkZoneName: "plp:filters",
        internalLinkURL: window.location.href,
        clickInternalLinks: "true"
    };
    const pageEvent = window.pageObj || {};
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const updatedPageEvent = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: updatedPageEvent,
        eventInfo: eventData
    });
};
const getTrackingAttributeForClearAllCTA = ()=>{
    return JSON.stringify({
        eventAction: "plp clear all filter",
        eventName: "plp clear all filter",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "clear all",
        internalLinkPosition: "plp",
        internalLinkType: "plp:clear all",
        internalLinkZoneName: "plp:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};


/***/ }),

/***/ 77593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cn": function() { return /* binding */ getProductInfo; },
/* harmony export */   "Gd": function() { return /* binding */ addLoadMoreAnalytics; },
/* harmony export */   "ZB": function() { return /* binding */ colorDataLayerHandle; },
/* harmony export */   "_d": function() { return /* binding */ handlePLPDataLayer; },
/* harmony export */   "lQ": function() { return /* binding */ dataLayerPush; },
/* harmony export */   "qW": function() { return /* binding */ removeProductFromListDataLayerPush; },
/* harmony export */   "sF": function() { return /* binding */ addBackToTopAnalytics; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; },
/* harmony export */   "y_": function() { return /* binding */ getPLPPaginationAnalyticsData; }
/* harmony export */ });
/* unused harmony exports searchGetBackToTopAnalytics, technicalSpecGetBackToTopAnalytics, plpGetBackToTopAnalytics, defaultGetBackToTopAnalytics, searchLoadMoreAnalyticsData, technicalSpecLoadMoreAnalyticsData, articleLoadMoreAnalyticsData, defaultLoadMoreAnalyticsData, addSortAnalytics, getAnalyticsData, getSortAnalyticsData */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/* harmony import */ var _components_PressRoomLanding_v1_pressRoomAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75744);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Threekit_ConfigurationPannel_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39637);





const searchGetBackToTopAnalytics = (type)=>JSON.stringify({
        eventAction: "search results:".concat(type, ":main content area:back to top"),
        eventName: "search results:".concat(type, ":main content area:back to top"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "back to top",
        internalLinkPosition: "search results",
        internalLinkType: "search results:navigation",
        internalLinkZoneName: "search results:".concat(type, ":main content area"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
const technicalSpecGetBackToTopAnalytics = JSON.stringify({
    eventAction: "technical specs:main content area:back to top",
    eventName: "technical specs:main content area:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "tech specs",
    internalLinkType: "technical specs:navigation",
    internalLinkZoneName: "technical specs:main content area",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const plpGetBackToTopAnalytics = JSON.stringify({
    eventAction: "plp:back to top",
    eventName: "plp:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "plp",
    internalLinkType: "plp:navigation",
    internalLinkZoneName: "plp:promo tiles",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const defaultGetBackToTopAnalytics = JSON.stringify({
    eventAction: "support:help and faq:article list:back to top",
    eventName: "support:help and faq:article list:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "support:help and faq",
    internalLinkType: "support:help and faq:navigation",
    internalLinkZoneName: "support:help and faq:article list",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const searchLoadMoreAnalyticsData = '{"eventAction":"search results:products:main content area:load more","eventName":"search results:products:main content area:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"search results","internalLinkType":"search results:load more","internalLinkZoneName":"search results:products:main content area","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const technicalSpecLoadMoreAnalyticsData = '{"eventAction":"technical specs:main content area:load more","eventName":"technical specs:main content area:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"tech specs","internalLinkType":"technical specs:load more","internalLinkZoneName":"technical specs:main content area","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const articleLoadMoreAnalyticsData = '{"eventAction":"support:help and faq:article list:load more","eventName":"support:help and faq:article list:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"support:help and faq","internalLinkType":"support:help and faq:load more","internalLinkZoneName":"support:help and faq:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const defaultLoadMoreAnalyticsData = '{"eventAction":"plp load more","eventName":"plp load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"plp","internalLinkType":"plp:load more","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const generatePressReleaseAnalyticsData = (type, actionType)=>{
    return '{\n    "clickInternalLinks": "true",\n    "eventAction": "press room:'.concat(type, ":").concat(actionType, '",\n    "eventMsg": "n/a",\n    "eventName": "press room:').concat(type, ":").concat(actionType, '",\n    "eventStatus": "n/a",\n    "eventType": "navigation",\n    "internalLinkName": "').concat(actionType, '",\n    "internalLinkPosition": "press room",\n    "internalLinkType": "press room:').concat(actionType, '",\n    "internalLinkURL": "n/a",\n    "internalLinkZoneName": "press room:').concat(type, ":").concat(actionType, '"\n  }');
};
const getLoadMoreAnalyticsData = function() {
    let page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    let analyticsData = "";
    if (page === "search") {
        analyticsData = searchLoadMoreAnalyticsData;
    } else if (page === "technicalspecs") {
        analyticsData = technicalSpecLoadMoreAnalyticsData;
    } else if (page === "article") {
        analyticsData = articleLoadMoreAnalyticsData;
    } else if (page === "press-release") {
        analyticsData = generatePressReleaseAnalyticsData("press releases", "load more");
    } else if (page === "press-kit") {
        analyticsData = generatePressReleaseAnalyticsData("press kit", "load more");
    } else {
        analyticsData = defaultLoadMoreAnalyticsData;
    }
    return JSON.parse(analyticsData);
};
const getBackToTopAnalyticsData = function(isSearchTab, page) {
    let type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    let eventInfo = "";
    if (isSearchTab && page === "search") {
        eventInfo = searchGetBackToTopAnalytics(type);
    } else if (page === "technicalspecs") {
        eventInfo = technicalSpecGetBackToTopAnalytics;
    } else if (page === "plp") {
        eventInfo = plpGetBackToTopAnalytics;
    } else if (page === "press-release") {
        eventInfo = generatePressReleaseAnalyticsData("press releases", "back to top");
    } else if (page === "press-kit") {
        eventInfo = generatePressReleaseAnalyticsData("press kit", "back to top");
    } else {
        eventInfo = defaultGetBackToTopAnalytics;
    }
    return JSON.parse(eventInfo);
};
const addLoadMoreAnalytics = function() {
    let page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const pageEvent = window.pageObj || {};
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const modifiedPageObj = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    const eventInfo = getLoadMoreAnalyticsData(page);
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click", modifiedPageObj);
};
const addSortAnalytics = (selectSort)=>{
    const eventInfo = getSortAnalyticsData(selectSort, {
        selectSort,
        page: "plp"
    }, "", true);
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addBackToTopAnalytics = function(isSearchTab) {
    let page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const pageEvent = window.pageObj || {};
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const modifiedPageObj = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    const eventInfo = getBackToTopAnalyticsData(isSearchTab, page);
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click", modifiedPageObj);
};
const getAnalyticsData = function(t, page) {
    let limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", all = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, selectedTab = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", pos = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "bottom";
    limit = limit + "";
    let analyticsData = "";
    if (page === "search") {
        if (!all) {
            analyticsData = JSON.stringify({
                eventAction: "search results:".concat(selectedTab, ":main content area:pagination"),
                eventName: "search results:".concat(selectedTab, ":main content area:pagination"),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: limit,
                internalLinkPosition: "search results",
                internalLinkType: "search results:pagination ".concat(pos),
                internalLinkZoneName: "search results:".concat(selectedTab, ":main content area"),
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            });
        } else {
            analyticsData = JSON.stringify({
                eventAction: "search results:".concat(selectedTab, ":main content area:pagination"),
                eventName: "search results:".concat(selectedTab, ":main content area:pagination"),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: t("kf.plp.label.all"),
                internalLinkPosition: "search results",
                internalLinkType: "search results:pagination ".concat(pos),
                internalLinkZoneName: "search results:".concat(selectedTab, ":main content area"),
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            });
        }
    } else if (page === "technicalspecs") {
        if (!all) {
            analyticsData = '{"eventAction":"technical specs:main content area​:pagination","eventName":"technical specs:main content area​:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"tech spec","internalLinkType":"technical specs​:pagination ' + pos + '","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        } else {
            analyticsData = '{"eventAction":"technical specs:main content area​:pagination","eventName":"technical specs:main content area​:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + t("kf.plp.label.all") + '","internalLinkPosition":"tech spec","internalLinkType":"technical specs​:pagination ' + pos + '","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        }
    } else if (page === "favorites") {
        if (!all) {
            analyticsData = JSON.stringify({
                eventAction: "my account:favorites:".concat(selectedTab, ":pagination"),
                eventName: "my account:favorites:".concat(selectedTab, ":pagination"),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(limit),
                internalLinkPosition: "favorites",
                internalLinkType: "my account:pagination bottom",
                internalLinkZoneName: "my account:favorites:".concat(selectedTab),
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            });
        } else {
            analyticsData = JSON.stringify({
                eventAction: "my account:favorites:".concat(selectedTab, ":pagination"),
                eventName: "my account:favorites:".concat(selectedTab, ":pagination"),
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "".concat(t("kf.plp.label.all")),
                internalLinkPosition: "favorites",
                internalLinkType: "my account:pagination bottom",
                internalLinkZoneName: "my account:favorites:".concat(selectedTab),
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            });
        }
    } else if (page === "article") {
        analyticsData = JSON.stringify({
            eventAction: "support:help and faq:article list:pagination",
            eventName: "support:help and faq:article list:pagination",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: !all ? limit : t("kf.plp.label.all"),
            internalLinkPosition: "knowledge articles",
            internalLinkType: "support:help and faq:pagination " + pos,
            internalLinkZoneName: "support:help and faq:article list",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        });
    } else if (page === "literature") {
        if (!all) {
            analyticsData = '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        } else {
            analyticsData = '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + t("kf.plp.label.all") + '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        }
    } else if (page === "press-release") {
        const type = "pagination";
        if (!all) {
            analyticsData = getPressRoomEventInfo(page, t("kf.PressRoom.label.title"), type, limit);
        } else {
            analyticsData = getPressRoomEventInfo(page, t("kf.PressRoom.label.title"), t("kf.plp.label.all"), type);
        }
    } else if (page === "press-kits") {
        if (!all) {
            analyticsData = '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        } else {
            analyticsData = '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + t("kf.plp.label.all") + '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        }
    } else if (page === "blog") {
        const pageCount = !all ? limit : "all";
        const category = selectedTab ? sanitizeTextForAnalytics(selectedTab) : "";
        const linkName = "view ".concat(pageCount);
        const blogCategory = category && category === "how tos" ? "how to's" : category;
        const linkUrl = "";
        let resolvedLinkUrl = "n/a";
        if (linkUrl) {
            resolvedLinkUrl = linkUrl.indexOf("http") === -1 ? window.location.origin + linkUrl : linkUrl;
        }
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "blog listing:".concat(blogCategory, ":main content area:pagination"),
            eventName: "blog listing:".concat(blogCategory, ":main content area:pagination"),
            eventType: "navigation",
            internalLinkName: linkName ? linkName : "pagination",
            internalLinkPosition: "blogs listing",
            internalLinkType: "blog listing:navigation",
            internalLinkZoneName: "blog listing:".concat(blogCategory, ":main content area"),
            internalLinkURL: resolvedLinkUrl
        };
        analyticsData = JSON.stringify(eventInfo);
    } else {
        const internalLinkZoneName = pos === "top" ? '"plp:sticky nav filter"' : '"plp:promo tiles"';
        if (!all) {
            analyticsData = '{"eventAction":"plp pagination ' + pos + '","eventName":"plp pagination ' + pos + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' + internalLinkZoneName + ',"internalLinkURL":"n/a","clickInternalLinks":"true"}';
        } else {
            analyticsData = '{"eventAction":"plp pagination ' + pos + '","eventName":"plp pagination ' + pos + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + t("kf.plp.label.all") + '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' + internalLinkZoneName + ',"internalLinkURL":"n/a","clickInternalLinks":"true"}';
        }
    }
    return analyticsData;
};
const getSortAnalyticsData = function(item, param, myListTitle) {
    let { selectedtab , page  } = param, needJson = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    let analyticsData = {
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(item),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (page === "search" && selectedtab === "technical") {
        analyticsData = {
            ...analyticsData,
            eventAction: "search results:technical:main content area:sort by",
            eventName: "search results:technical:main content area:sort by",
            internalLinkPosition: "search results",
            internalLinkType: "search results:sort by",
            internalLinkZoneName: "search results:technical:main content area"
        };
    }
    switch(page){
        case "search":
            analyticsData = {
                ...analyticsData,
                eventAction: "search results:".concat(selectedtab, ":main content area:sort by"),
                eventName: "search results:".concat(selectedtab, ":main content area:sort by"),
                internalLinkPosition: "search results",
                internalLinkType: "search results:sort by",
                internalLinkZoneName: "search results:".concat(selectedtab, ":main content area")
            };
            break;
        case "favorites":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:".concat(myListHeading, ":").concat(selectedtab, ":sort by"),
                eventName: "my account:".concat(myListHeading, ":").concat(selectedtab, ":sort by"),
                internalLinkPosition: "my account:".concat(myListHeading, ":").concat(selectedtab),
                internalLinkType: "my account:".concat(myListHeading, ":").concat(item),
                internalLinkZoneName: "my account:".concat(myListHeading, ":").concat(selectedtab)
            };
            break;
        case "article":
            analyticsData = {
                ...analyticsData,
                eventAction: "support:help and faq:article list​:sort by",
                eventName: "support:help and faq:article list​:sort by",
                internalLinkPosition: "knowledge articles",
                internalLinkType: "support:help and faq:sort by",
                internalLinkZoneName: "support:help and faq:article list​​"
            };
            break;
        case "active-services":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:services:active services​:sort by",
                eventName: "my account:services:active services​:sort by",
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:active services"
            };
            break;
        case "past-services":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:services:past services​:sort by",
                eventName: "my account:services:past services​:sort by",
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:past services"
            };
            break;
        case "literature":
            analyticsData = {
                ...analyticsData,
                eventAction: "literature:sort by",
                eventName: "literature:sort by",
                internalLinkPosition: "literature",
                internalLinkType: "literature:sort by",
                internalLinkZoneName: "literature:main content area"
            };
            break;
        case "press-release":
            analyticsData = {
                ...analyticsData,
                eventAction: "press room:press releases:sort by",
                eventName: "press room:press releases:sort by",
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press releases:main content area"
            };
            break;
        case "press-kits":
            analyticsData = {
                ...analyticsData,
                eventAction: "press room:press kits:sort by",
                eventName: "press room:press kits:sort by",
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press kits:main content area"
            };
            break;
        case "my products":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:products:sort by filter",
                eventName: "my account:products:sort by filter",
                internalLinkPosition: "my account",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:products"
            };
            break;
        default:
            analyticsData = {
                ...analyticsData,
                eventAction: "plp sort by filter",
                eventName: "plp sort by filter",
                internalLinkPosition: "plp",
                internalLinkType: "plp:sort by",
                internalLinkZoneName: "plp:sort by filter"
            };
    }
    if (needJson) return analyticsData;
    return JSON.stringify(analyticsData);
};
/**
 * common data layer function
 * @param {*} e
 */ const handlePLPDataLayer = (e)=>{
    const target = e.target.closest('[data-datalayer-id="kds-element-plp"]');
    if (target) {
        var ref, ref1, ref2, ref3;
        const eventInfo = JSON.parse((target === null || target === void 0 ? void 0 : (ref = target.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref["data-datalayer-data"]) === null || ref1 === void 0 ? void 0 : ref1.nodeValue) || "{}");
        const productInfo = JSON.parse((target === null || target === void 0 ? void 0 : (ref2 = target.attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2["data-datalayer-data-product"]) === null || ref3 === void 0 ? void 0 : ref3.nodeValue) || "{}");
        const page = window.pageObj || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    }
};
const getEventBaseInfo = (prefix, type, alternameType)=>{
    const actionSuffix = alternameType || type || "navigation";
    const eventNameAndAction = type.includes(_constants_index__WEBPACK_IMPORTED_MODULE_2__.QUICK_VIEW) ? "".concat(prefix, ":").concat(actionSuffix) : "".concat(prefix, " ").concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.PRODUCT, " ").concat(actionSuffix);
    return {
        eventAction: eventNameAndAction.trim(),
        eventName: eventNameAndAction.trim(),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
};
const getInternalLinkInfo = (prefix, plpPage, selectedTabForSearchResults, type)=>{
    const internalLinkType = type.includes(_constants_index__WEBPACK_IMPORTED_MODULE_2__.CLOSE) ? "".concat(prefix, ":").concat(type.split(":".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.CLOSE))[0]) : "".concat(prefix, ":").concat(type || "navigation");
    const zoneSuffix = plpPage ? _constants_index__WEBPACK_IMPORTED_MODULE_2__.PROMO_TILES : "".concat(selectedTabForSearchResults, ":main content area");
    return {
        internalLinkType,
        internalLinkZoneName: type.includes(_constants_index__WEBPACK_IMPORTED_MODULE_2__.QUICK_VIEW) ? type.includes(_constants_index__WEBPACK_IMPORTED_MODULE_2__.CLOSE) ? "".concat(prefix, ":").concat(type) : "".concat(prefix, ":").concat(zoneSuffix, ":").concat(type) : "".concat(prefix, ":").concat(zoneSuffix),
        internalLinkPosition: plpPage ? type.includes(_constants_index__WEBPACK_IMPORTED_MODULE_2__.CLOSE) ? "".concat(prefix, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.PROMO_TILES, ":").concat(type.split(":".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.CLOSE))[0]) : prefix : "search results"
    };
};
const getSkuIdParam = (color, skuCode)=>{
    if (color) return "?skuId=".concat(color.sku);
    if (skuCode) return "?skuId=".concat(skuCode);
    return "";
};
const getLinkName = (type, alternameType, propsProductCard)=>{
    if (type === _constants_index__WEBPACK_IMPORTED_MODULE_2__.COLOR) return _components_Threekit_ConfigurationPannel_constants__WEBPACK_IMPORTED_MODULE_4__/* .COLOR_SELECTION_ID */ .Kq;
    return alternameType || (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(type || propsProductCard.product.productName);
};
const getInternalLinkNameForType = (type, sterling, compareInternalLinkName)=>{
    if (sterling) return _constants_index__WEBPACK_IMPORTED_MODULE_2__.SEARCH_INTERNAL_TYPE.sterlingResults;
    if (type === _constants_index__WEBPACK_IMPORTED_MODULE_2__.SEARCH_INTERNAL_TYPE.compare) return compareInternalLinkName;
    if (type === _constants_index__WEBPACK_IMPORTED_MODULE_2__.SEARCH_INTERNAL_TYPE.partsDiagram) return _constants_index__WEBPACK_IMPORTED_MODULE_2__.SEARCH_INTERNAL_TYPE.serviceParts;
    return type;
};
const getEventInfo = function(type, color) {
    let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isForSample = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, sterling = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, message = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", isChecked = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, propsProductCard = arguments.length > 7 ? arguments[7] : void 0, index = arguments.length > 8 ? arguments[8] : void 0, internalLinkName = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : "", internalLinkURLVal = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : "";
    var ref;
    const fullUrl = propsProductCard.fullUrl;
    const skuCode = propsProductCard.product.sku;
    const productCollectionsName = propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.productCollectionsName;
    // Setup basic variables
    const plpPage = true;
    const prefix = isForSample ? "plp:sample" : "plp";
    const selectedTabForSearchResults = type || "products";
    // Get alternate type and compare status
    let alternameType = "";
    if (type === "favorite") {
        alternameType = message.includes("removed") ? "favorite remove" : "favorite add";
    } else if (type === "compare") {
        alternameType = isChecked ? "compare add" : "compare remove";
    }
    let compareInternalLinkName = "";
    if (type === "compare") {
        compareInternalLinkName = isChecked ? "add to compare" : "remove compare";
    }
    // Get internal link URL
    const skuIdParam = getSkuIdParam(color, skuCode);
    const internalLinkURL = internalLinkURLVal || (!type ? "".concat(fullUrl).concat(skuIdParam) : "n/a");
    // Build event info object
    const baseEventInfo = getEventBaseInfo(prefix, type, alternameType);
    const linkInfo = getInternalLinkInfo(prefix, plpPage, selectedTabForSearchResults, type);
    const linkName = getLinkName(type, alternameType, propsProductCard);
    let eventInfo = {
        ...baseEventInfo,
        ...linkInfo,
        productGridPosition: index + 1,
        internalLinkName: type ? [
            _constants_index__WEBPACK_IMPORTED_MODULE_2__.QUICK_VIEW,
            _constants_index__WEBPACK_IMPORTED_MODULE_2__.CLOSE
        ].every((val)=>type.includes(val)) ? "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.CLOSE) : getInternalLinkNameForType(linkName, sterling, compareInternalLinkName) : productCollectionsName,
        internalLinkURL: internalLinkURLVal || (propsProductCard.product.isSterling && "object" !== "undefined" ? window.location.href : internalLinkURL),
        clickInternalLinks: "true",
        ...(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getSearchDataLayerDetails */ .g1g)({})
    };
    if (type.includes(_constants_index__WEBPACK_IMPORTED_MODULE_2__.QUICK_VIEW)) {
        eventInfo.modalName = _constants_index__WEBPACK_IMPORTED_MODULE_2__.QUICK_VIEW_MODAL;
    }
    // Override event type for samples/favorites
    if (isForSample || type === "favorite") {
        eventInfo.eventType = "wishlist save";
    }
    if (type === "share") {
        eventInfo = {
            ...eventInfo,
            eventAction: "plp product share",
            eventName: "plp product share",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkPosition: "plp",
            internalLinkType: "plp:share",
            internalLinkZoneName: "plp:promo tiles",
            clickInternalLinks: "false",
            internalLinkName: internalLinkName || "share"
        };
    }
    return needsJSON ? eventInfo : JSON.stringify(eventInfo);
};
const getColorDetails = (color, data)=>{
    var ref;
    const colorDetail = (ref = data["Color.SKU.Details_ss"]) !== null && ref !== void 0 ? ref : [];
    const colorInfo = color ? colorDetail.find((item)=>item.split("|")[2] === color.sku) : null;
    var ref1, ref2;
    return {
        colorName: (ref1 = colorInfo === null || colorInfo === void 0 ? void 0 : colorInfo.split("|")[0]) !== null && ref1 !== void 0 ? ref1 : "",
        inStock: (ref2 = colorInfo === null || colorInfo === void 0 ? void 0 : colorInfo.split("|")[3]) !== null && ref2 !== void 0 ? ref2 : ""
    };
};
const getDescription = (data, isGrouped)=>{
    return isGrouped ? lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(data, "Collapse_Description_s", "") : lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(data, "ProductDescriptionProductShort_s", "");
};
const getProductId = (color, data, sterling, propsProductCard, skuPrepend)=>{
    const sterlingData = [];
    if (sterling && sterlingData.length) {
        var ref;
        var ref1;
        return (ref1 = (ref = sterlingData[0]) === null || ref === void 0 ? void 0 : ref.sku_s) !== null && ref1 !== void 0 ? ref1 : "";
    }
    return (color === null || color === void 0 ? void 0 : color.customerFacingSKU) || propsProductCard.customerFacingSKU || data["masterCustomerFacingSKU_s"] || "".concat(skuPrepend.toLowerCase()).concat(data === null || data === void 0 ? void 0 : data.masterSKU_s) || "n/a";
};
const getBaseProductInfo = (description, category, productRoom, general, propsProductCard)=>{
    var ref;
    const datalayerProductRoom = productRoom === "n/a" || productRoom === undefined ? category : productRoom;
    return {
        productBrand: general === null || general === void 0 ? void 0 : (ref = general.siteName) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
        description: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(description) || "n/a",
        globalPromotionPrice: propsProductCard.product.globalPromotionPrice || "n/a",
        priceState: propsProductCard.product.priceState || "regular price",
        productBasePrice: propsProductCard.product.productBasePrice || "n/a",
        productCategory: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(category) || "n/a",
        productRoom: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(datalayerProductRoom) || "n/a",
        productSalePrice: propsProductCard.product.productSalePrice || "n/a",
        productSaleable: !!propsProductCard.product.productSaleable
    };
};
const getProductStatus = (color, inStock, propsProductCard)=>{
    if (color) {
        return inStock === "true" || inStock === true ? "in stock" : "out of stock";
    }
    return propsProductCard.product.productStatus ? "in stock" : "out of stock";
};
const getProductInfo = function() {
    let color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", needsJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, sterling = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, cartData = arguments.length > 3 ? arguments[3] : void 0, propsProductCard = arguments.length > 4 ? arguments[4] : void 0, locale = arguments.length > 5 ? arguments[5] : void 0, skuPrepend = arguments.length > 6 ? arguments[6] : void 0, general = arguments.length > 7 ? arguments[7] : void 0;
    const skuCode = propsProductCard.product.sku;
    const { productCouponCode , productCoupondiscount  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentSkuCouponDiscounts */ .mPk)({
        cart: cartData,
        sku: skuCode,
        locale: locale
    });
    const data = propsProductCard.originaldata;
    const { colorName , inStock  } = getColorDetails(color, data);
    const description = getDescription(data, propsProductCard.isGrouped);
    const productId = getProductId(color, data, sterling, propsProductCard, skuPrepend);
    const category = propsProductCard.product.category;
    const productRoom = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(data, "category1_s", "n/a");
    const baseInfo = getBaseProductInfo(description, category, productRoom, general, propsProductCard);
    const product = propsProductCard.product;
    const productInfo = {
        productInfo: {
            ...baseInfo,
            productBrand: sterling ? "sterling" : baseInfo.productBrand,
            productColor: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(colorName || product.productColor) || "n/a",
            productID: productId,
            productName: product.productName || (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(description) || "n/a",
            productStatus: getProductStatus(color, inStock, propsProductCard),
            productSuperSku: product.isSuperSku,
            productTileName: product.productTileName || "n/a",
            defaultImageName: propsProductCard.defaultImageName || "n/a",
            productCollectionsName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(category || product.productCollectionsName),
            globalOffer: product.badgeValue || "n/a",
            globalDiscount: product.discountPercent ? product.discountAmount : "n/a",
            productPartnerBuyNow: product.productIsRetail,
            pdpType: product.isBundleProduct ? "bundle" : "regular finished goods & service parts",
            productCouponCode: productCouponCode.join("|") || "n/a",
            productCoupondiscount,
            productFindingMethod: "n/a",
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            quantity: "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a"
        }
    };
    return needsJSON ? productInfo.productInfo : JSON.stringify(productInfo);
};
const colorDataLayerHandle = function(propsProductCard, index, cartData, locale, skuPrepend, general) {
    let type = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, internalLinkName = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", internalLinkURL = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "";
    const page = window.pageObj || {};
    const eventInfo = getEventInfo(type, propsProductCard.product, true, false, false, "", false, propsProductCard, index, internalLinkName, internalLinkURL);
    const productInfo = getProductInfo(propsProductCard.product, true, false, cartData, propsProductCard, locale, skuPrepend, general);
    if (type.includes(_constants_index__WEBPACK_IMPORTED_MODULE_2__.QUICK_VIEW)) {
        var ref;
        productInfo.category = productInfo["productCategory"] || "n/a";
        productInfo.itemType = _constants_index__WEBPACK_IMPORTED_MODULE_2__.PRODUCT;
        productInfo.waterSenseProduct = propsProductCard.originaldata["ProductWaterSense_ss"] || false;
        const defaultImage = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.defaultImageName) && productInfo.defaultImageName.includes("PAWEB") ? productInfo === null || productInfo === void 0 ? void 0 : (ref = productInfo.defaultImageName) === null || ref === void 0 ? void 0 : ref.split("PAWEB/")[0] : "n/a";
        page.pageInfo.defaultImage = defaultImage;
        page.pageInfo.imageId = defaultImage;
        page.pageInfo.resourceType = _constants_index__WEBPACK_IMPORTED_MODULE_2__.IMG_ITEM_ISO;
    }
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    page.pageInfo.contentType = pageType;
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo
    });
};
const dataLayerPush = (message, status, type, isChecked, propsProductCard, index, cartData, locale, skuPrepend, general)=>{
    var ref;
    const page = window.pageObj || {};
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    page.pageInfo.contentType = pageType;
    let isForSample = false;
    if (page && (page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.subCategory1)) {
        const { category: { subCategory1  }  } = page;
        isForSample = subCategory1.includes("samples");
    }
    const eventInfo = getEventInfo(type, null, true, isForSample, "", message, isChecked, propsProductCard, index);
    const productInfo = getProductInfo("", true, false, cartData, propsProductCard, locale, skuPrepend, general);
    eventInfo.eventStatus = status;
    eventInfo.eventMsg = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(message);
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo
    });
};
const removeProductFromListDataLayerPush = (eventType, productInfo)=>{
    const pageEvent = window.pageObj || {};
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "plp:product details:".concat(eventType),
        eventMsg: "n/a",
        eventName: "plp:product details:".concat(eventType),
        eventStatus: "n/a",
        eventType: "wishlist ".concat(eventType === "delete from list" ? "delete" : "save"),
        internalLinkName: eventType,
        internalLinkPosition: "plp",
        internalLinkType: eventType,
        internalLinkURL: "n/a",
        internalLinkZoneName: eventType
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: pageEvent,
        eventInfo,
        productInfo
    });
};
const getPLPPaginationAnalyticsData = (currentPerPage)=>{
    const pageEvent = window.pageObj || {};
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "plp pagination bottom",
        eventMsg: "n/a",
        eventName: "plp pagination bottom",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(currentPerPage),
        internalLinkPosition: "plp",
        internalLinkType: "plp:pagination",
        internalLinkURL: "n/a",
        internalLinkZoneName: "plp:promo tiles"
    };
    const pageType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPageType */ .C2B)();
    const updatedPageEvent = {
        ...pageEvent,
        pageInfo: {
            ...pageEvent.pageInfo || {},
            contentType: pageType
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: updatedPageEvent,
        eventInfo
    });
};


/***/ }),

/***/ 39637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DD": function() { return /* binding */ REGULAR_PRICE; },
/* harmony export */   "EF": function() { return /* binding */ FLUSH_INFO_OVERRIDES; },
/* harmony export */   "Gf": function() { return /* binding */ BATHROOM; },
/* harmony export */   "Hf": function() { return /* binding */ ACCORDION_ORDER; },
/* harmony export */   "ID": function() { return /* binding */ LAST_MOBILE_STEP_INDEX; },
/* harmony export */   "Kq": function() { return /* binding */ COLOR_SELECTION_ID; },
/* harmony export */   "M9": function() { return /* binding */ UPSELL; },
/* harmony export */   "QU": function() { return /* binding */ INSTALL_ITEMS_INFO_OVERRIDES; },
/* harmony export */   "T7": function() { return /* binding */ BASE_PRODUCT_INFO; },
/* harmony export */   "YV": function() { return /* binding */ CROSS_SELL; },
/* harmony export */   "bz": function() { return /* binding */ MAX_INNER_WIDTH; },
/* harmony export */   "dJ": function() { return /* binding */ MOBILE_SLIDE_TO_SECTION; },
/* harmony export */   "iM": function() { return /* binding */ NO_SEAT_INFO_OVERRIDES; }
/* harmony export */ });
/* unused harmony exports LEFT_HAND_TRIP_LEVER, TOILET_ACCESSORIES, CORBELLE, SERVICE_PARTS, REGULAR_FINISHED_GOODS, TOILET_SEATS */
/* harmony import */ var _components_Threekit_FlushHandlePlacement_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25117);
/* harmony import */ var _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57746);


const ACCORDION_ORDER = [
    "color",
    "flushingtech",
    "bowlheight",
    "handle",
    "seat",
    "installItems"
];
const LAST_MOBILE_STEP_INDEX = 5;
const MAX_INNER_WIDTH = 1023;
const MOBILE_SLIDE_TO_SECTION = [
    "color",
    "flushingtech",
    "bowlheight",
    "handle",
    "seat",
    "installItems"
];
const BATHROOM = "bathroom";
const LEFT_HAND_TRIP_LEVER = "left-hand trip lever";
const REGULAR_PRICE = "regular price";
const TOILET_ACCESSORIES = "toilet accessories";
const CORBELLE = "corbelle";
const SERVICE_PARTS = "service parts";
const REGULAR_FINISHED_GOODS = "regular finished goods";
const TOILET_SEATS = "toilet seats";
const COLOR_SELECTION_ID = "color selection";
const CROSS_SELL = "cross-sell";
const UPSELL = "upsell";
const BASE_PRODUCT_INFO = {
    componentName: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__/* .COMPONENT_NAME */ .lP,
    bundleIds: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    bundleProductColors: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    defaultImageName: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    frequency: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    globalDiscount: 0,
    globalOffer: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    globalPromotionPrice: 0,
    isRecommended: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    isSendNow: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    isSubscription: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    itemType: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__/* .ITEMTYPE */ .RO,
    numberOfReviews: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    priceState: REGULAR_PRICE,
    productBasePrice: 0,
    productType: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productCouponCode: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productCoupondiscount: 0,
    productFindingMethod: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productPartnerBuyNow: "false",
    productSalePrice: 0,
    productSuperSku: "false",
    quantity: 1,
    ratings: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    waterSenseProduct: "false"
};
const FLUSH_INFO_OVERRIDES = {
    category: BATHROOM,
    description: LEFT_HAND_TRIP_LEVER,
    pdpType: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__/* .PDPTYPE */ ._6,
    productCategory: TOILET_ACCESSORIES,
    productCollectionsName: CORBELLE,
    productColor: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productID: "K-".concat(_components_Threekit_FlushHandlePlacement_constants__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_SKU */ .ZR),
    productName: CORBELLE,
    productRoom: BATHROOM,
    productSaleable: "true",
    productStatus: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__/* .STOCK */ .Dy,
    productTileName: CORBELLE
};
const INSTALL_ITEMS_INFO_OVERRIDES = {
    category: SERVICE_PARTS,
    description: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    pdpType: REGULAR_FINISHED_GOODS,
    productCategory: SERVICE_PARTS,
    productCollectionsName: SERVICE_PARTS,
    productColor: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__/* .NOT_APPLICABLE */ .LE,
    productID: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productName: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productRoom: SERVICE_PARTS,
    productSaleable: "true",
    productStatus: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productTileName: SERVICE_PARTS,
    quantity: 0
};
const NO_SEAT_INFO_OVERRIDES = {
    category: BATHROOM,
    description: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__/* .NO_SEAT.toLocaleLowerCase */ .w3.toLocaleLowerCase(),
    pdpType: REGULAR_FINISHED_GOODS,
    productBrand: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productCategory: TOILET_SEATS,
    productCollectionsName: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productColor: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productID: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productName: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productRoom: BATHROOM,
    productSaleable: "false",
    productStatus: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    productTileName: _components_Threekit_analytics_constants__WEBPACK_IMPORTED_MODULE_0__.NA,
    quantity: 0
};


/***/ }),

/***/ 25117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hv": function() { return /* binding */ FLUSH_SIDES; },
/* harmony export */   "Kh": function() { return /* binding */ RIGHT_TRIP_LEVER_TAG; },
/* harmony export */   "O4": function() { return /* binding */ LEFT_TRIP_LEVER_TAG; },
/* harmony export */   "VO": function() { return /* binding */ TRIP_TAG; },
/* harmony export */   "ZR": function() { return /* binding */ DEFAULT_SKU; }
/* harmony export */ });
/* unused harmony export FLUSH_HANDLE_PLACEMENT */
const FLUSH_SIDES = [
    "left",
    "right"
];
const LEFT_TRIP_LEVER_TAG = "Left-Hand Trip Lever";
const RIGHT_TRIP_LEVER_TAG = "Right-Hand Trip Lever";
const TRIP_TAG = "Trip Lever";
const DEFAULT_SKU = "20120-L-SN-ChromeDefault";
const FLUSH_HANDLE_PLACEMENT = "Flush Handle Placement";


/***/ }),

/***/ 57746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AH": function() { return /* binding */ ACCORDION_TO_SECTION; },
/* harmony export */   "AK": function() { return /* binding */ PDP_DEATAIL; },
/* harmony export */   "Ac": function() { return /* binding */ BEGIN_DESIGN; },
/* harmony export */   "B": function() { return /* binding */ PRICE_AMT_F; },
/* harmony export */   "BV": function() { return /* binding */ SUPER_SKU; },
/* harmony export */   "Dy": function() { return /* binding */ STOCK; },
/* harmony export */   "EA": function() { return /* binding */ SALE_OFFER; },
/* harmony export */   "Fy": function() { return /* binding */ COMBO_SKU_AVAILABLE; },
/* harmony export */   "G2": function() { return /* binding */ ADD_TO_CART; },
/* harmony export */   "Hn": function() { return /* binding */ NONE; },
/* harmony export */   "Hs": function() { return /* binding */ PDP; },
/* harmony export */   "Jr": function() { return /* binding */ MANUAL_COLLAPSE; },
/* harmony export */   "LE": function() { return /* binding */ NOT_APPLICABLE; },
/* harmony export */   "LL": function() { return /* binding */ PRICE_D; },
/* harmony export */   "NA": function() { return /* binding */ NA; },
/* harmony export */   "Ng": function() { return /* binding */ POSITION_PDP; },
/* harmony export */   "OF": function() { return /* binding */ PRODUCT_LOCAL_CATEGORY; },
/* harmony export */   "P7": function() { return /* binding */ PRODUCT_WATER_SENSE; },
/* harmony export */   "Q$": function() { return /* binding */ SEAT; },
/* harmony export */   "QY": function() { return /* binding */ PRICE_LIST; },
/* harmony export */   "R": function() { return /* binding */ BOWL_HEIGHT_SECTION; },
/* harmony export */   "RO": function() { return /* binding */ ITEMTYPE; },
/* harmony export */   "RQ": function() { return /* binding */ BOWL_HEIGHT_SELECTION; },
/* harmony export */   "Rd": function() { return /* binding */ HANDLE_SELECTION; },
/* harmony export */   "Sx": function() { return /* binding */ PRODUCT_BRAND_NAME_DISPLAY_S; },
/* harmony export */   "Ub": function() { return /* binding */ SEAT_SECTION; },
/* harmony export */   "VX": function() { return /* binding */ SUMMARY_TRACKING; },
/* harmony export */   "WT": function() { return /* binding */ PRODUCT_DESC_SHORT; },
/* harmony export */   "_6": function() { return /* binding */ PDPTYPE; },
/* harmony export */   "_I": function() { return /* binding */ COLOR_SELECTION; },
/* harmony export */   "a5": function() { return /* binding */ INSTALL_ITEMS; },
/* harmony export */   "dx": function() { return /* binding */ NOT_APPLICABLE_SRCH; },
/* harmony export */   "eo": function() { return /* binding */ INSTALL_ITEMS_SELECTION; },
/* harmony export */   "g4": function() { return /* binding */ SECTION_MAP; },
/* harmony export */   "gT": function() { return /* binding */ YES; },
/* harmony export */   "if": function() { return /* binding */ MASTER_SKU; },
/* harmony export */   "ii": function() { return /* binding */ FLUSHING_TECHNOLOGY; },
/* harmony export */   "k2": function() { return /* binding */ NAVIGATION; },
/* harmony export */   "lP": function() { return /* binding */ COMPONENT_NAME; },
/* harmony export */   "ls": function() { return /* binding */ TOILETS; },
/* harmony export */   "mb": function() { return /* binding */ COLOR_SECTION; },
/* harmony export */   "nL": function() { return /* binding */ SWATCH_NA; },
/* harmony export */   "nQ": function() { return /* binding */ CONFIGURATOR_MODAL; },
/* harmony export */   "oG": function() { return /* binding */ FLUSHING_TECH_SELECTION; },
/* harmony export */   "oR": function() { return /* binding */ COLOR_SKU_DETAILS_SS; },
/* harmony export */   "pV": function() { return /* binding */ FLUSH_HANDLE; },
/* harmony export */   "qj": function() { return /* binding */ CROSS_UPSELL; },
/* harmony export */   "qw": function() { return /* binding */ INSTALL_ITEMS_SECTION; },
/* harmony export */   "ru": function() { return /* binding */ PRODUCT_CATEGORY; },
/* harmony export */   "s7": function() { return /* binding */ FLUSHING_TECH_SECTION; },
/* harmony export */   "s9": function() { return /* binding */ PRODUCTIMAGES_LABEL_URL; },
/* harmony export */   "t": function() { return /* binding */ PERCENTOFF; },
/* harmony export */   "to": function() { return /* binding */ PRODUCT_IS_RETAIL; },
/* harmony export */   "u5": function() { return /* binding */ CATEGORY_S; },
/* harmony export */   "uQ": function() { return /* binding */ FINAL_PRICE_D; },
/* harmony export */   "vf": function() { return /* binding */ FLUSH_HANDLE_SECTION; },
/* harmony export */   "w3": function() { return /* binding */ NO_SEAT; },
/* harmony export */   "wP": function() { return /* binding */ BOWL_HEIGHT; },
/* harmony export */   "xK": function() { return /* binding */ CACHET_SEAT; },
/* harmony export */   "yo": function() { return /* binding */ DISCOUNTED_PRICE_D; },
/* harmony export */   "yw": function() { return /* binding */ CUSTOMER_FACING_BRAND_S; },
/* harmony export */   "zb": function() { return /* binding */ NEXT; }
/* harmony export */ });
/* unused harmony export CONVERSION */
const PDP = "pdp";
const PDP_DEATAIL = "product details";
const NAVIGATION = "navigation";
const CONFIGURATOR_MODAL = "configurator modal";
const BEGIN_DESIGN = "begin your design here";
const NEXT = "next";
const CONVERSION = "conversion";
const MANUAL_COLLAPSE = "manual collapse";
const SUMMARY_TRACKING = "summary";
const ADD_TO_CART = "add to cart";
const COLOR_SELECTION = "color";
const BOWL_HEIGHT_SELECTION = "bowlheight";
const FLUSHING_TECH_SELECTION = "flushingtech";
const HANDLE_SELECTION = "handle";
const FLUSHING_TECHNOLOGY = "flushing technology";
const INSTALL_ITEMS_SELECTION = "installItems";
const BOWL_HEIGHT = "toilet height";
const FLUSH_HANDLE = "flush location";
const SEAT = "seat";
const INSTALL_ITEMS = "Complete your project";
const NO_SEAT = "No Seat";
const NONE = "None";
const NOT_APPLICABLE = "not applicable";
const SWATCH_NA = "swatch_NA";
const NOT_APPLICABLE_SRCH = "Not Applicable";
const ITEMTYPE = "product";
const PDPTYPE = "regular finished goods";
const STOCK = "in stock";
const COLOR_SECTION = "Color/Finish";
const FLUSHING_TECH_SECTION = "Flushing Technology";
const BOWL_HEIGHT_SECTION = "Bowl Height";
const FLUSH_HANDLE_SECTION = "Flush Handle Placement";
const SEAT_SECTION = "Seat";
const INSTALL_ITEMS_SECTION = "Install Items";
const POSITION_PDP = "pdp";
const COMPONENT_NAME = "configurator";
const NA = "n/a";
const TOILETS = "toilets";
const YES = "Yes";
const PERCENTOFF = "percentOff|";
const CACHET_SEAT = "cachet";
const CROSS_UPSELL = "cross-sell + upsell";
const SECTION_MAP = {
    [COLOR_SECTION]: COLOR_SELECTION,
    [FLUSHING_TECH_SECTION]: FLUSHING_TECHNOLOGY,
    [BOWL_HEIGHT_SECTION]: BOWL_HEIGHT,
    [FLUSH_HANDLE_SECTION]: FLUSH_HANDLE,
    [SEAT_SECTION]: SEAT,
    [INSTALL_ITEMS_SECTION]: INSTALL_ITEMS
};
const ACCORDION_TO_SECTION = {
    color: COLOR_SECTION,
    bowlheight: BOWL_HEIGHT_SECTION,
    flushingtech: FLUSHING_TECH_SECTION,
    handle: FLUSH_HANDLE_SECTION,
    seat: SEAT_SECTION,
    installitems: INSTALL_ITEMS_SECTION
};
const COLOR_SKU_DETAILS_SS = "Color.SKU.Details_ss";
const CUSTOMER_FACING_BRAND_S = "CustomerFacingBrand_s";
const PRODUCT_BRAND_NAME_DISPLAY_S = "ProductBrandNameDisplay_s";
const PRODUCT_LOCAL_CATEGORY = "ProductLocalCategory_s";
const PRODUCT_DESC_SHORT = "ProductDescriptionProductShort_s";
const PRODUCT_CATEGORY = "Product_Category";
const PRICE_AMT_F = "Price_Amt_f";
const SUPER_SKU = "Super_Sku";
const MASTER_SKU = "masterSKU_s";
const PRODUCTIMAGES_LABEL_URL = "productImages.labelWithUrl_ss";
const PRODUCT_WATER_SENSE = "ProductWaterSense_ss";
const PRICE_LIST = "priceList";
const PRICE_D = "price_d";
const FINAL_PRICE_D = "finalPrice_d";
const DISCOUNTED_PRICE_D = "discountedPrice_d";
const SALE_OFFER = "saleOffer_s";
const PRODUCT_IS_RETAIL = "ProductIsRetail";
const COMBO_SKU_AVAILABLE = "comboSKUAvailable_b";
const CATEGORY_S = "category1_s";


/***/ }),

/***/ 48375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67166);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11763);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2595);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);









const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart , isCartLoading  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        let timeoutId;
        if (!isSsr) {
            timeoutId = setTimeout(()=>{
                if (!accessToken || !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)()) {
                    dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .getOktaToken */ .cs)("guest"));
                }
            }, 5000);
        }
        // eslint-disable-next-line no-extra-semi
        return ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        accessToken,
        isSsr
    ]);
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            if (!isCartLoading) {
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                    if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getCurrency */ .zC$)().then((currency)=>{
                            const cartPayload = {
                                currency: currency,
                                taxMode: "ExternalAmount"
                            };
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                            });
                        });
                    } else {
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                    }
                });
            }
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 69663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _components_ProductList_v3_analytics_analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77593);
/* harmony import */ var _components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65258);
/* harmony import */ var _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4943);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24899);
/* harmony import */ var _store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7737);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88751);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24400);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);








const useProductFavorites = ()=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    // Function to get favorite icon status
    const getFavIconStatus = function(isSaveProductToList, productSavedToList, userListItemsSkusRef, favoritesRef, skuCode, productDataId) {
        let isCurrentlyFavoriteOverride = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
        var ref;
        const inSavedItems = userListItemsSkusRef.current[skuCode];
        const isCurrentlyFavorite = isCurrentlyFavoriteOverride !== null ? isCurrentlyFavoriteOverride : (ref = favoritesRef.current) === null || ref === void 0 ? void 0 : ref.some((fav)=>fav.productId === productDataId);
        let favIconStatus = false;
        if (isSaveProductToList) {
            favIconStatus = productSavedToList || inSavedItems;
        } else {
            favIconStatus = isCurrentlyFavorite;
        }
        return favIconStatus;
    };
    // click fav if not login then login
    const handleLogin = (e, cartData, propsProductCard, setLoginFavouriteCallback, locale, skuPrepend, general)=>{
        (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_6__/* .dataLayerSavetolistGuest */ .OR)((0,_components_ProductList_v3_analytics_analytics__WEBPACK_IMPORTED_MODULE_0__/* .getProductInfo */ .Cn)("", true, false, cartData, propsProductCard, locale, skuPrepend, general));
        window.loginFavouriteCallback = ()=>{
            setLoginFavouriteCallback(e);
        };
        dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_1__/* .setAuthModalVisibility */ .LY)({
            show: true
        }));
    };
    const handleCallBack = (status, message, isChecked, propsProductCard, index, cartData, locale, skuPrepend, general)=>{
        (0,_components_ProductList_v3_analytics_analytics__WEBPACK_IMPORTED_MODULE_0__/* .dataLayerPush */ .lQ)(message, status, "favorite", isChecked, propsProductCard, index, cartData, locale, skuPrepend, general);
    };
    // Handle favorite icon click
    const handleFavorite = function(e) {
        let { favoritesRef , userListItemsSkusRef , productDataId , masterSKU , setOpenModal , setDeleteFromList , setShowAddToList , setLoginFavouriteCallback , toasterContent , propsProductCard , cartData , isChecked , index , locale , skuPrepend , general , isSaveProductToList , isAuthenticated , skipDataLayer =false  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!favoritesRef || !userListItemsSkusRef || !propsProductCard) {
            console.error("handleFavorite: Missing required parameters.", {
                favoritesRef,
                userListItemsSkusRef,
                propsProductCard
            });
            return;
        }
        const skuCode = propsProductCard.product.sku;
        const currentFavorites = favoritesRef.current || [];
        const currentUserListItemsSkus = userListItemsSkusRef.current || [];
        const isCurrentlyFavorite = currentFavorites === null || currentFavorites === void 0 ? void 0 : currentFavorites.some((fav)=>fav.productId === productDataId);
        const productInfo = (0,_components_ProductList_v3_analytics_analytics__WEBPACK_IMPORTED_MODULE_0__/* .getProductInfo */ .Cn)("", true, false, cartData, propsProductCard, locale, skuPrepend, general);
        if (isSaveProductToList) {
            if (currentUserListItemsSkus[skuCode]) {
                setOpenModal(true);
                setDeleteFromList(true);
                if (!skipDataLayer) {
                    (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_6__/* .dataLayerHeartClickSaveListButton */ .y3)(productInfo, "delete from list", _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_7__/* .WISHLIST_DELETE */ .Ik);
                }
                (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_6__/* .dataLayerHeartClickSaveListButton */ .y3)(productInfo, "delete from list", _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_7__/* .WISHLIST_DELETE */ .Ik);
                return;
            }
            setShowAddToList(true);
            if (!skipDataLayer) {
                (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_6__/* .dataLayerHeartClickSaveListButton */ .y3)(productInfo, "save to list", _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_7__/* .WISHLIST_SAVE */ .O1);
            }
            window.loginFavouriteCallback = null;
            setLoginFavouriteCallback(null);
            return;
        }
        if (isCurrentlyFavorite) {
            currentFavorites === null || currentFavorites === void 0 ? void 0 : currentFavorites.map((fav)=>{
                if (fav.productId === productDataId) {
                    if (!isAuthenticated) {
                        handleLogin(e, cartData, propsProductCard, setLoginFavouriteCallback, locale, skuPrepend, general);
                    } else {
                        dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_2__/* .removeItems */ .Er)({
                            ids: [
                                fav.id
                            ],
                            isDataLayerNeeded: false
                        })).unwrap().then(()=>{
                            if (!skipDataLayer) {
                                handleCallBack("success", t("kf.favorites.removeItem"), isChecked, propsProductCard, index, cartData);
                            }
                            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .showToast */ .CF)({
                                message: toasterContent.unfavoriteSuccessMessage || t("kf.favorites.removeItem"),
                                isVisible: true
                            }));
                        }).catch((err)=>{
                            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .showToast */ .CF)({
                                message: t("kf.favorites.removeItemError"),
                                isVisible: true
                            }));
                            if (!skipDataLayer) {
                                handleCallBack("failure", t("kf.favorites.removeItemError"), isChecked, propsProductCard, index, cartData);
                            }
                        });
                    }
                }
            });
        } else {
            if (!isAuthenticated) {
                handleLogin(e, cartData, propsProductCard, setLoginFavouriteCallback);
            } else {
                dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_2__/* .addProduct */ .gK)(skuCode)).unwrap().then(()=>{
                    if (!skipDataLayer) {
                        handleCallBack("success", t("kf.favorites.success"), isChecked, propsProductCard, index, cartData);
                    }
                    dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .showToast */ .CF)({
                        message: toasterContent.successMessage || t("kf.favorites.success"),
                        isVisible: true
                    }));
                }).catch((err)=>{
                    dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .showToast */ .CF)({
                        message: t("kf.favorites.error"),
                        isVisible: true
                    }));
                    if (!skipDataLayer) {
                        handleCallBack("failure", t("kf.favorites.error"), isChecked, propsProductCard, index, cartData);
                    }
                });
            }
        }
        window.loginFavouriteCallback = null;
        setLoginFavouriteCallback(null);
    };
    return {
        getFavIconStatus,
        handleFavorite,
        handleLogin
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useProductFavorites);


/***/ }),

/***/ 86255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bi": function() { return /* binding */ plpFilterArrayFormatter; },
/* harmony export */   "Ev": function() { return /* binding */ colorFetcheslogic; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "V9": function() { return /* binding */ reformatFacetString; },
/* harmony export */   "W5": function() { return /* binding */ calculateProductPricing; },
/* harmony export */   "ZO": function() { return /* binding */ formatFacets; },
/* harmony export */   "dY": function() { return /* binding */ getPlpProcessedData; },
/* harmony export */   "ei": function() { return /* binding */ getFacetFieldWithLabel; },
/* harmony export */   "iG": function() { return /* binding */ plpSortArrayFormatter; },
/* harmony export */   "u2": function() { return /* binding */ getBadgesData; },
/* harmony export */   "w8": function() { return /* binding */ isPriceRangeFilter; }
/* harmony export */ });
/* unused harmony exports transformProductCards, getFacetFieldByLabel, reformatSortString, isKeyValuePresent, getUniversalUrl */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55760);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20558);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96301);
/* harmony import */ var _components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89150);
/* harmony import */ var _utils_announceForAccessibility__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67318);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49139);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "|"
    ], [
        "\\|"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "|"
    ], [
        "\\|"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "|"
    ], [
        "\\|"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}








const facetFieldsColor = "ColorFinish_s";
const getViewportWidth = ()=>{
    if (true) {
        return window.innerWidth;
    }
    // Default width for server-side rendering
    return 1024;
};
const extractProductName = (item, isSterling, sterlingData, isGrouped, type)=>{
    if (isSterling && (sterlingData === null || sterlingData === void 0 ? void 0 : sterlingData.length) > 0) {
        var ref;
        return ((ref = sterlingData[0]) === null || ref === void 0 ? void 0 : ref["ProductBrandName_s"]) || "";
    }
    if (isGrouped && (item === null || item === void 0 ? void 0 : item["Collapse_Title_s"])) {
        return item["Collapse_Title_s"];
    }
    if ((type === null || type === void 0 ? void 0 : type.toLowerCase()) === "parts") {
        return (item === null || item === void 0 ? void 0 : item["productName_s"]) || "";
    }
    return (item === null || item === void 0 ? void 0 : item["RegionBrandName_s"]) || (item === null || item === void 0 ? void 0 : item["productName_s"]) || "";
};
// calculate price for data layer
const calculateDataLayerPrices = (item, persona, colors)=>{
    var ref;
    const price = (ref = item === null || item === void 0 ? void 0 : item["priceStartingAt.".concat(persona, "_d")]) !== null && ref !== void 0 ? ref : null;
    var ref1;
    const isDiscountedPrice = (ref1 = item === null || item === void 0 ? void 0 : item["priceList.".concat(persona, ".discountedPrice_d")]) !== null && ref1 !== void 0 ? ref1 : "";
    const discountAmount = price - isDiscountedPrice || 0;
    var ref2;
    const badgeVal = (ref2 = item === null || item === void 0 ? void 0 : item["priceList.".concat(persona, ".saleOffer_s")]) !== null && ref2 !== void 0 ? ref2 : "";
    const discountPercent = badgeVal && isDiscountedPrice ? 100 - Math.round(isDiscountedPrice / price * 100) : 0;
    const globalPromotionPrice = discountPercent && discountAmount < price ? Number((price - discountAmount).toFixed(2)) : price;
    var ref3;
    const productIsRetail = (ref3 = item === null || item === void 0 ? void 0 : item["ProductIsRetail"]) !== null && ref3 !== void 0 ? ref3 : false;
    return {
        globalPromotionPrice,
        priceState: badgeVal && isDiscountedPrice ? "percentOff|" + discountPercent : "regular price",
        productBasePrice: price,
        productSalePrice: isDiscountedPrice || price,
        productSaleable: !(productIsRetail || !colors.length)
    };
};
/**
 * Processes PLP (Product Listing Page) data and transforms it into a standardized format
 * @param {Object} inputObj - The input object containing raw PLP data
 * @param {boolean} isSterling - Flag indicating if the data is for Sterling
 * @param {Array} sterlingData - Array containing Sterling-specific data
 * @param {string} type - The type of products being processed
 * @param {Object} configParams - Additional params for transformation
 * @param {Object} plpPresetConfig - for image settings
 * @return {Object} Processed PLP data with standardized structure
 */ const getPlpProcessedData = async function() {
    let inputObj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isSterling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, sterlingData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], type = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", configParams = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, plpPresetConfig = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
    var ref;
    const newData = {};
    const isGrouped = inputObj.grouped;
    var ref1;
    const isCollapsePLP = (ref1 = inputObj === null || inputObj === void 0 ? void 0 : (ref = inputObj.fusion) === null || ref === void 0 ? void 0 : ref.isCollapsePLP) !== null && ref1 !== void 0 ? ref1 : false;
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getUserPersona */ .shu)();
    // First process raw data
    Object.entries(inputObj).forEach((param)=>{
        let [key, value] = param;
        if (Array.isArray(value) && key === "data") {
            newData.data = value.map((item)=>{
                var ref, ref1;
                // Extract productName logic
                const productName = extractProductName(item, isSterling, sterlingData, isGrouped, type);
                // Extract pricing information
                const fieldValue = item === null || item === void 0 ? void 0 : item["Collapse_Field_s"];
                const swatchColor = inputObj === null || inputObj === void 0 ? void 0 : inputObj.PlpSwatches.filter((swatchObj)=>swatchObj[fieldValue]);
                let colors;
                if ((inputObj === null || inputObj === void 0 ? void 0 : (ref = inputObj.fusion) === null || ref === void 0 ? void 0 : ref.isCollapsePLP) && swatchColor.length) {
                    colors = swatchColor[0][fieldValue];
                } else if (item === null || item === void 0 ? void 0 : item["Color.SKU.Details_ss"]) {
                    colors = item === null || item === void 0 ? void 0 : item["Color.SKU.Details_ss"];
                } else {
                    colors = (item === null || item === void 0 ? void 0 : item["Color.".concat(persona, ".Details_ss")]) || [];
                }
                const { globalPromotionPrice , priceState , productBasePrice , productSalePrice , productSaleable  } = calculateDataLayerPrices(item, persona, colors);
                var ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
                return {
                    isCollapsePLP: isCollapsePLP,
                    isSterling: isSterling,
                    originalData: item,
                    isGrouped: isGrouped,
                    description: isGrouped && (item === null || item === void 0 ? void 0 : item["Collapse_Description_s"]) && !(item === null || item === void 0 ? void 0 : item["sku_s"].includes("BNDL")) ? item === null || item === void 0 ? void 0 : item["Collapse_Description_s"] : (()=>{
                        const shortDescription = item === null || item === void 0 ? void 0 : item["ProductDescriptionProductShort_s"];
                        var ref;
                        return (ref = shortDescription || (item === null || item === void 0 ? void 0 : item["Collapse_Description_s"])) !== null && ref !== void 0 ? ref : "";
                    })(),
                    colors: colors,
                    collapseField: (item === null || item === void 0 ? void 0 : item["Collapse_Field_s"]) ? item === null || item === void 0 ? void 0 : item["Collapse_Field_s"] : null,
                    resourceNvznId: (item === null || item === void 0 ? void 0 : item["ResourceNvznId_s"]) ? item === null || item === void 0 ? void 0 : item["ResourceNvznId_s"] : null,
                    regionIsBackOrderable: (item === null || item === void 0 ? void 0 : item["RegionIsBackOrderable_b"]) ? item === null || item === void 0 ? void 0 : item["RegionIsBackOrderable_b"] : false,
                    resourceVntanaProductId: (item === null || item === void 0 ? void 0 : item["ResourceVntanaProductId_s"]) ? item === null || item === void 0 ? void 0 : item["ResourceVntanaProductId_s"] : null,
                    resourceVntanaProductIdList: (item === null || item === void 0 ? void 0 : item["ResourceVntanaProductIdList_ss"]) ? item === null || item === void 0 ? void 0 : item["ResourceVntanaProductIdList_ss"] : [],
                    resourceNvznIdList: (item === null || item === void 0 ? void 0 : item["ResourceNvznIdList_ss"]) ? item === null || item === void 0 ? void 0 : item["ResourceNvznIdList_ss"] : [],
                    productIsExclusive: (item === null || item === void 0 ? void 0 : item["ProductIsExclusive_s"]) ? item === null || item === void 0 ? void 0 : item["ProductIsExclusive_s"] : null,
                    slug: (item === null || item === void 0 ? void 0 : item["slug_s"]) ? item === null || item === void 0 ? void 0 : item["slug_s"] : null,
                    productNo: (item === null || item === void 0 ? void 0 : item["ProductProductNo_s"]) ? item === null || item === void 0 ? void 0 : item["ProductProductNo_s"] : null,
                    resourceName: (item === null || item === void 0 ? void 0 : item["ProductResource.InteractiveSVG.resourceName_ss"]) ? item === null || item === void 0 ? void 0 : item["ProductResource.InteractiveSVG.resourceName_ss"] : "",
                    resourceTitle: (ref2 = item === null || item === void 0 ? void 0 : item["ProductResource.InteractiveSVG.resourceTitle_ss"]) !== null && ref2 !== void 0 ? ref2 : "",
                    productName: productName !== null && productName !== void 0 ? productName : null,
                    productTileName: productName !== null && productName !== void 0 ? productName : null,
                    category: (ref4 = (ref3 = item === null || item === void 0 ? void 0 : item["Product_Category"]) !== null && ref3 !== void 0 ? ref3 : item === null || item === void 0 ? void 0 : item["ProductLocalCategory_s"]) !== null && ref4 !== void 0 ? ref4 : "",
                    shipmentDate: (ref5 = item === null || item === void 0 ? void 0 : item["RegionReleaseforShipment_dt"]) !== null && ref5 !== void 0 ? ref5 : "",
                    badgeValue: (ref6 = item === null || item === void 0 ? void 0 : item["priceList.".concat(persona, ".saleOffer_s")]) !== null && ref6 !== void 0 ? ref6 : "",
                    productIsRetail: (item === null || item === void 0 ? void 0 : item["ProductIsRetail"]) === "true",
                    isSuperSku: Boolean(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(item, "comboSKUAvailable_b", false)),
                    productRoom: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(item, "category1_s", "n/a"),
                    productCollectionsName: lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(item, "ProductBrandNameDisplay_s", "n/a"),
                    productVariantImages: (item === null || item === void 0 ? void 0 : item["productImages.labelWithUrl_ss"]) ? item === null || item === void 0 ? void 0 : item["productImages.labelWithUrl_ss"] : [],
                    sku: (item === null || item === void 0 ? void 0 : item["Bundle_s"]) === "Yes" && (item === null || item === void 0 ? void 0 : (ref1 = item["variantList.sku_ss"]) === null || ref1 === void 0 ? void 0 : ref1[0]) ? item === null || item === void 0 ? void 0 : item["variantList.sku_ss"][0] : (ref7 = item === null || item === void 0 ? void 0 : item["sku_s"]) !== null && ref7 !== void 0 ? ref7 : item === null || item === void 0 ? void 0 : item["masterSKU_s"],
                    masterCustomerFacingSku: (ref8 = item === null || item === void 0 ? void 0 : item["masterCustomerFacingSKU_s"]) !== null && ref8 !== void 0 ? ref8 : "",
                    productCategory: (ref9 = item === null || item === void 0 ? void 0 : item["Product_Category"]) !== null && ref9 !== void 0 ? ref9 : "",
                    isBundleProduct: Boolean(item === null || item === void 0 ? void 0 : item["primaryBundleSKU_s"]) || (item === null || item === void 0 ? void 0 : item["ctProductType_s"]) === "static-bundle-parent",
                    bundlePLPImageURL: (ref10 = item === null || item === void 0 ? void 0 : item["BundlePLPImageURL_s"]) !== null && ref10 !== void 0 ? ref10 : null,
                    bundleFlag: (ref11 = item === null || item === void 0 ? void 0 : item["Bundle_s"]) !== null && ref11 !== void 0 ? ref11 : null,
                    displayPriceStartingAt: (ref12 = item === null || item === void 0 ? void 0 : item["min_price"]) !== null && ref12 !== void 0 ? ref12 : null,
                    globalPromotionPrice,
                    priceState,
                    productBasePrice,
                    productSalePrice,
                    productSaleable,
                    allVariantsDiscontinued: Boolean(item === null || item === void 0 ? void 0 : item["productRegionAllVariantDiscontinued_b"])
                };
            });
        }
    });
    // Now transform the processed data into card format
    try {
        const transformedCards = await Promise.resolve(transformProductCards(newData === null || newData === void 0 ? void 0 : newData.data, configParams.configdata, configParams.swatchUrl, configParams.plpServletPath, configParams.general, null, plpPresetConfig));
        newData.facets = inputObj.facets;
        newData.facetLabels = inputObj.facetLabels;
        newData.fusion = inputObj.fusion;
        newData.total = inputObj.total;
        newData.colors = inputObj.colors;
        newData.isGrouped = isGrouped;
        return {
            ...newData,
            transformedCards
        };
    } catch (error) {
        console.error("Error transforming product cards in getPlpProcessedData:", error);
        return {
            ...newData,
            transformedCards: []
        };
    }
};
/**
 * Transforms product data into card format for display
 * @param {Array} products - Array of product objects to transform
 * @param {Object} configdata - Configuration data for product cards
 * @param {string} swatchUrl - Base URL for color swatch images
 * @param {string} plpServletPath - PLP servlet path for URL construction
 * @param {Object} general - General configuration settings
 * @param {Object} selectedColor - Currently selected color information
 * @param {Object} plpPresetConfig - Currently selected color information
 * @return {Array} Array of transformed product card objects
 */ const transformProductCards = async (products, configdata, swatchUrl, plpServletPath, general, selectedColor, plpPresetConfig)=>{
    const width = getViewportWidth();
    try {
        // Input validation
        if (!products || !Array.isArray(products)) {
            return [];
        }
        // Transform products
        return products.map((product)=>{
            var ref, ref1;
            // Validate product
            if (!product) return null;
            // Get SKU - use variantList.sku_ss[0] for bundles, otherwise use masterCustomerFacingSku or product.sku
            let sku = "K-" + product.sku || 0;
            // For bundle products, use variantList.sku_ss[0] if available
            if (product.bundleFlag === "Yes" && ((ref = product.originalData) === null || ref === void 0 ? void 0 : (ref1 = ref["variantList.sku_ss"]) === null || ref1 === void 0 ? void 0 : ref1[0])) {
                sku = product.originalData["variantList.sku_ss"][0];
            }
            if (!sku) return null;
            try {
                var ref2, ref3;
                // Process product data
                // if selectColor the fetch sku based on that
                const selectedSku = product === null || product === void 0 ? void 0 : (ref2 = product.colors) === null || ref2 === void 0 ? void 0 : ref2.find((color)=>{
                    return (color === null || color === void 0 ? void 0 : color.split("|")[5]) === (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.customerFacingSKU);
                });
                if (selectedSku) sku = selectedSku === null || selectedSku === void 0 ? void 0 : selectedSku.split("|")[5];
                const allowedColorCount = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getSwatchCount */ .m3S)(true);
                const allColorsData = colorFetcheslogic(product, width, swatchUrl);
                let extraColors = 0;
                if (allColorsData.length > allowedColorCount) {
                    extraColors = allColorsData.length - allowedColorCount;
                }
                const colors = (allColorsData === null || allColorsData === void 0 ? void 0 : allColorsData.slice(0, allowedColorCount)) || [];
                const badgesdata = getBadgesData(product, configdata) || [];
                const url = getProductUrl(product, plpServletPath, general);
                const fullUrl =  false ? 0 : "".concat(window.location.origin).concat(url);
                const isBundle = product.bundleFlag === "Yes";
                let swatchImageId = "";
                let swatchImages = (product === null || product === void 0 ? void 0 : product.isCollapsePLP) && !isBundle && !product.isBundleProduct && (product === null || product === void 0 ? void 0 : (ref3 = product.originaldata) === null || ref3 === void 0 ? void 0 : ref3["colorSkuSlugListDetails_ss"].length) > 0 ? product === null || product === void 0 ? void 0 : product.originaldata["colorSkuSlugListDetails_ss"] : product === null || product === void 0 ? void 0 : product.variantImages;
                swatchImages = swatchImages === null || swatchImages === void 0 ? void 0 : swatchImages.find((img)=>selectedColor ? selectedColor.sku === img.split("|")[0] : product.sku === img.split("|")[0]);
                let imgUrl = "";
                let defaultImageName = "";
                if (swatchImages) {
                    var ref4;
                    swatchImages = swatchImages === null || swatchImages === void 0 ? void 0 : swatchImages.split("|");
                    const swatchIndex = (product === null || product === void 0 ? void 0 : product.isCollapsePLP) && !isBundle && !product.isBundleProduct ? swatchImages.length - 2 : swatchImages.length - 1;
                    const swatchImageValues = (ref4 = swatchImages[swatchIndex]) === null || ref4 === void 0 ? void 0 : ref4.split("/");
                    swatchImageId = swatchImageValues[swatchImageValues.length - 1];
                    imgUrl = (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .getPresetUrl */ .v$)(width, width <= 1024 ? 2 : 3, general.swatchUrl, swatchImageId, plpPresetConfig);
                    defaultImageName = swatchImageId;
                }
                // Create product object
                const newProductObj = {
                    type: "Product Card",
                    isGrouped: product.isGrouped,
                    isCollapsePLP: product.isCollapsePLP,
                    isSterling: product.isSterling,
                    sterlingData: product.sterlingData || [],
                    variantImages: product.productVariantImages,
                    variantColors: product.colors,
                    product: product,
                    originaldata: product.originalData,
                    fullUrl: fullUrl,
                    defaultImageName: defaultImageName || "",
                    image: {
                        src: imgUrl,
                        alt: product.productName || "Product Image",
                        reveal: "default",
                        loading: "blank"
                    },
                    isSaved: false,
                    saveCTA: null,
                    title: {
                        text: product.productName || ""
                    },
                    description: {
                        text: product.description || ""
                    },
                    productDetails: {
                        colorSwatches: {
                            colors,
                            extraColors: extraColors,
                            selectedColor: null,
                            onColorSelected: null
                        },
                        tags: badgesdata,
                        SKU: {
                            text: sku
                        }
                    }
                };
                return newProductObj;
            } catch (error) {
                console.log("Error processing product ".concat(sku, ":"), error);
                return null;
            }
        }).filter(Boolean) // Remove null values
        ;
    } catch (error) {
        console.error("Error in transformProductCards:", error);
        return [];
    }
};
/**
 * Processes color data for product swatches
 * @param {Object} data - Product data containing color information
 * @param {number} width - Screen width for responsive image URLs
 * @param {string} swatchUrl - Base URL for color swatch images
 * @return {Array} Array of processed color swatch objects
 */ function colorFetcheslogic(data, width, swatchUrl) {
    let colorsTemp = [];
    if (data.colors) {
        colorsTemp = data.colors.map((color)=>{
            const d = color === null || color === void 0 ? void 0 : color.split("|");
            // Use desktop preset for server-side rendering
            const preset = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getSwatchPreset */ .Z8v)(width);
            const imgURL = "".concat(swatchUrl).concat(d[1]).concat(preset);
            const imgObj = {
                src: imgURL,
                alt: d[0],
                reveal: "default",
                loading: "blank"
            };
            const colorObj = {
                colorName: d[0],
                title: d[0],
                image: imgObj,
                shape: "square",
                size: "small",
                swatch: d[1],
                sku: d[2],
                isStock: d[3],
                isDiscontinued: d[4],
                customerFacingSKU: d[5],
                id: d[2],
                // All event handlers will be attached client-side
                onMouseEnter: null,
                onMouseLeave: null,
                productData: {
                    sku: d[2],
                    customerFacingSKU: d[5],
                    image: imgURL,
                    colorName: d[0],
                    isStock: d[3]
                }
            };
            return colorObj;
        });
    }
    const colorsTempVal = colorsTemp.filter((item)=>{
        var ref;
        return ((ref = item.swatch) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== _constants_index__WEBPACK_IMPORTED_MODULE_5__.SWATCH_NA.toLowerCase() && (item.isDiscontinued === "false" || Date.parse(item.isDiscontinued) > Date.now());
    });
    return colorsTempVal;
}
/**
 * Checks if a product has 3D visualization capabilities
 * @param {Object} data - Product data containing 3D resource information
 * @return {boolean} True if product has 3D resources available
 */ const isThreeDBadgeAvailable = (data)=>{
    var ref, ref1;
    return data["resourceNvznId"] || data["resourceVntanaProductId"] || ((ref = data["resourceVntanaProductIdList"]) === null || ref === void 0 ? void 0 : ref.length) || ((ref1 = data["resourceNvznIdList"]) === null || ref1 === void 0 ? void 0 : ref1.length);
};
/**
 * Gets badge data based on product information and configuration
 * @param {Object} product - Product object containing badge-related properties
 * @param {Object} configdata - Configuration object containing badge settings
 * @return {Array} Array of badge objects for display
 */ const getBadgesData = (product, configdata)=>{
    const plpBadges = getdefaultBades(configdata.plpBadgeList);
    const abc = plpBadges.filter((item)=>{
        const isNew = item.key.includes("new") && (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .showNewBadge */ .ZTk)(product.shipmentDate);
        const isSale = item.key.includes("sale") && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(product.badgeValue);
        const is3D = item.key.includes("3d") && isThreeDBadgeAvailable(product);
        const isExclusive = item.key.includes("exclusive") && ((0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .parseToBoolean */ .DD)(product.productIsExclusive) || (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .parseToBoolean */ .DD)(product === null || product === void 0 ? void 0 : product["ProductIsExclusive_s"]));
        const isSet = item.key.includes("bundleBadge") && (product.bundleFlag === "Yes" || product.Bundle_s === "Yes");
        return isNew || isSale || is3D || isExclusive || isSet;
    });
    return abc;
};
/**
 * Processes the badge list to get default badges configuration
 * @param {Array} plpBadgeList - List of available badges with their configurations
 * @return {Array} Array of processed badge objects with label and key properties
 */ function getdefaultBades(plpBadgeList) {
    var ref;
    const displayOrderBadges = (ref = plpBadgeList.find((item)=>item.map.Key === "displayOrderBadges")) !== null && ref !== void 0 ? ref : {};
    const { map: { Values: { myArrayList: displayOrderBadgeList = []  } = {}  } = {}  } = displayOrderBadges;
    const plpBadges = [];
    displayOrderBadgeList.forEach((item)=>{
        const badgeData = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getBadgeValue */ .FcF)(item, plpBadgeList);
        plpBadges.push({
            label: badgeData.value,
            key: badgeData.key
        }) // variant:badgeData.key,
        ;
    });
    return plpBadges;
}
/**
 * Constructs the product URL based on product data and configuration
 * @param {Object} product - Product object containing category and slug
 * @param {string} plpServletPath - PLP servlet path for URL construction
 * @param {Object} general - General configuration settings
 * @return {string} Constructed product URL
 */ const getProductUrl = (product, plpServletPath, general)=>{
    if (!(plpServletPath === null || plpServletPath === void 0 ? void 0 : plpServletPath.length) || !(product === null || product === void 0 ? void 0 : product.category) || !(product === null || product === void 0 ? void 0 : product.slug)) {
        return "";
    }
    return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getPDPUrlWithConfig */ .Upy)(product.category, product.slug, plpServletPath, general);
};
// Helper Function
/**
 * Finds the facet field key by its label.
 * @param {string} label - The label to search for (may contain underscores).
 * @param {Object} labelsObj - An object mapping facet field keys to their labels.
 * @return {string|undefined} The facet field key if found, otherwise undefined.
 */ function getFacetFieldByLabel(label, labelsObj) {
    if (label === "Price_Range") {
        return "Price_Range";
    } else {
        // Replace underscores with spaces for comparison
        const normalizedLabel = label.replace(/_/g, " ");
        return Object.keys(labelsObj).find((key)=>labelsObj[key].replace(/_/g, " ") === normalizedLabel);
    }
}
/**
 * Constructs the product URL based on product data and configuration
 * @param {string} facetString - If URL has query params as facets, should render cards accordingly from serverside
 * @param {string} facetLabels - If URL has query params as facets, should render cards accordingly from serverside
 * @param {string} persona - The user persona used for facet processing
 * @param {boolean} isCanadaCheck - Flag indicating if the Canada site check should be applied
 * @return {string} Constructed API query params for fq
 */ function reformatFacetString(facetString, facetLabels, persona, isCanadaCheck) {
    if (!facetString) return [];
    // Remove the prefix "facet:'" and the trailing "'"
    const cleaned = facetString.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_7__/* .FACET_FORMAT_REGEX */ .HS, "");
    // Split into key-value pairs
    const pairs = cleaned === null || cleaned === void 0 ? void 0 : cleaned.split(",");
    // Transform each pair
    const formatted = pairs.map((pair)=>{
        const [key, value] = pair.split(":");
        if (!key || !value) return "";
        // Find the facet field using facet_labels
        let tagKey = getFacetFieldByLabel(key, facetLabels) || key;
        // If Price_Range, get label from facetFieldWithLabel
        if (tagKey === "Price_Range" || key === "Price_Range") {
            tagKey = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getPriceFieldFromFacet */ .KF8)(facetLabels, persona) || tagKey;
            // No quotes for Price_Range values
            // Split by unescaped pipe and join with OR
            const values = value === null || value === void 0 ? void 0 : value.split(_constants_regex__WEBPACK_IMPORTED_MODULE_7__/* .PIPE_NOT_PRECEDED_BY_BACKSLASH_REGEX */ .iD).map((v)=>v.trim().replace(/"/g, '\\"')).join(" OR ").replaceAll(String.raw(_templateObject()), "|");
            return encodeURIComponent('{!tag="'.concat(tagKey, '"}').concat(tagKey, ":(").concat(values, ")"));
        } else {
            // Quotes for all other keys
            // Split by unescaped pipe and join with OR
            const values1 = value === null || value === void 0 ? void 0 : value.split(_constants_regex__WEBPACK_IMPORTED_MODULE_7__/* .PIPE_NOT_PRECEDED_BY_BACKSLASH_REGEX */ .iD).map((v)=>'"'.concat(v.trim().replace(/"/g, '\\"'), '"')).join(" OR ").replaceAll(String.raw(_templateObject1()), "|");
            return encodeURIComponent('{!tag="'.concat(tagKey, '"}').concat(tagKey, ":(").concat(values1, ")"));
        }
    });
    return formatted;
}
/**
 * Reformats a sort string using the facetFieldWithLabel mapping.
 * If the sort string exists in the mapping, returns the mapped value; otherwise, returns the original sort string.
 * @param {string} sortString - The sort string to reformat.
 * @param {string} persona - The user persona used for sort field mapping.
 * @param {boolean} isCanadaCheck - Flag indicating if the Canada site check should be applied.
 * @return {string} The reformatted sort string or the original if no mapping exists.
 */ function reformatSortString(sortString, persona, isCanadaCheck) {
    if (!sortString) return null;
    return getFacetFieldWithLabel(sortString, persona, isCanadaCheck);
}
/**
 * Gets facet field mappings based on params and persona using switch statement
 * @param {string} params - The facet parameter to map
 * @param {string} persona - User persona (default: "GST")
 * @param {boolean} isCanadaCheck - Flag indicating if the Canada site check should be applied
 * @return {string} The mapped facet field value
 */ const getFacetFieldWithLabel = function(params) {
    let persona = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GST", isCanadaCheck = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    switch(params){
        case "Price_Range":
            if (isCanadaCheck) {
                return "priceList.".concat(persona, ".price_d");
            }
            return "priceList.".concat(persona, ".finalPrice_d");
        case "price desc":
            if (isCanadaCheck) {
                return "priceList.".concat(persona, ".price_d desc");
            }
            return "priceList.".concat(persona, ".finalPrice_d desc");
        case "price asc":
            if (isCanadaCheck) {
                return "priceList.".concat(persona, ".price_d asc");
            }
            return "priceList.".concat(persona, ".finalPrice_d asc");
        case "featured":
            return "";
        default:
            return null;
    }
};
/**
 * Checks if a key-value pair is present in an array of "key - value" strings.
 * @param {string[]} array - The array of strings in the format "key - value".
 * @param {string} attributeName - The key to search for.
 * @param {string} attributeValue - The value to search for.
 * @return {boolean} True if the key-value pair exists, false otherwise.
 */ function isKeyValuePresent(array, attributeName, attributeValue) {
    return array.some((item)=>{
        const [key, value] = item.split(" - ").map((str)=>str.trim());
        return key === attributeName && value === attributeValue;
    });
}
/**
 * Returns the input field variant type based on the facet field.
 * @param {string} item - The facet field name.
 * @return {string} The input field variant ("colorSwatchCheckbox" for color facets, otherwise "checkbox").
 */ const getInptfieldsVarient = (item)=>{
    if (item === facetFieldsColor) {
        return "colorSwatchCheckbox";
    } else {
        return "checkbox";
    }
};
/**
 * Determines if the given facet field represents a price range filter.
 * @param {string} filterFacet - The facet field name to check.
 * @return {boolean} True if the facet is a price range filter, false otherwise.
 */ const isPriceRangeFilter = (filterFacet)=>{
    return filterFacet && (filterFacet === _constants_index__WEBPACK_IMPORTED_MODULE_5__.PRICE_RANGE || filterFacet === _constants_index__WEBPACK_IMPORTED_MODULE_5__.PriceRangeFrench || filterFacet === _constants_index__WEBPACK_IMPORTED_MODULE_5__.PRICE_RANGE_FRENCH_LOCALE || filterFacet.includes(_constants_index__WEBPACK_IMPORTED_MODULE_5__.DISCOUNTED_PRICE_FACET_LABEL));
};
/**
 * Finds and returns formatted attribute values for a given facet and filter query.
 * @param {Array} dataArray - The facet data array, where the first element is the facet name and the second is the values array.
 * @param {Object} facetLabels - An object mapping facet field keys to their labels.
 * @param {string} attributeName - The attribute (facet) name to match.
 * @param {string} attributeValue - The attribute value to match.
 * @param {string} filterQuery - The filter query string (e.g., "ColorFinish_s:White|Black").
 * @return {string[]} An array of formatted "Facet - Value" strings matching the criteria.
 */ const findAttributeValue = (dataArray, facetLabels, attributeName, attributeValue, filterQuery)=>{
    // Handle empty filter query with specific attribute
    if (filterQuery === "" && attributeName !== "" && attributeValue !== "") {
        return handleEmptyFilterQuery(dataArray, attributeName, attributeValue);
    }
    // Handle filter query processing
    if (filterQuery !== "") {
        return processFilterQuery(dataArray, facetLabels, filterQuery);
    }
    return [];
};
/**
 * Handles the case when filter query is empty but attribute name and value are provided
 * @param {Array} dataArray - The facet data array
 * @param {string} attributeName - The attribute name to match
 * @param {string} attributeValue - The attribute value to match
 * @return {string[]} Array of formatted attribute values
 */ const handleEmptyFilterQuery = (dataArray, attributeName, attributeValue)=>{
    if (!Array.isArray(dataArray) || dataArray.length < 2) {
        return [];
    }
    const facetName = dataArray[0].replace(/\*\*/g, "");
    if (facetName !== attributeName) {
        return [];
    }
    const valuesArray = dataArray[1];
    for(let i = 0; i < valuesArray.length; i += 2){
        if (valuesArray[i] === attributeValue) {
            return [
                "".concat(attributeName, " - ").concat(valuesArray[i])
            ];
        }
    }
    return [];
};
/**
 * Processes the filter query string to extract matching facet values
 * @param {Array} dataArray - The facet data array
 * @param {Object} facetLabels - Mapping of facet field keys to labels
 * @param {string} filterQuery - The filter query string
 * @return {string[]} Array of formatted facet values
 */ const processFilterQuery = (dataArray, facetLabels, filterQuery)=>{
    if (!Array.isArray(dataArray) || dataArray.length < 2) {
        return [];
    }
    const facets = splitFilterQuery(filterQuery);
    const result = [];
    const targetFacetName = dataArray[0].replace(/\*\*/g, "");
    for (const facet of facets){
        const facetResults = processSingleFacet(facet, facetLabels, targetFacetName, result);
        result.push(...facetResults);
    }
    return [
        ...new Set(result)
    ];
};
/**
 * Splits the filter query into individual facet groups
 * @param {string} filterQuery - The filter query string
 * @return {string[]} Array of individual facet strings
 */ const splitFilterQuery = (filterQuery)=>{
    return filterQuery.includes(",") ? filterQuery.split(",") : [
        filterQuery
    ];
};
/**
 * Processes a single facet string and returns matching formatted values
 * @param {string} facet - Single facet string (e.g., "ColorFinish_s:White|Black")
 * @param {Object} facetLabels - Mapping of facet field keys to labels
 * @param {string} targetFacetName - The target facet name to match against
 * @param {string[]} existingResults - Already processed results to avoid duplicates
 * @return {string[]} Array of formatted facet values for this facet
 */ const processSingleFacet = (facet, facetLabels, targetFacetName, existingResults)=>{
    const facetParts = parseFacetString(facet);
    if (!facetParts) {
        return [];
    }
    const { facetName , facetValues  } = facetParts;
    const labelKey = getFacetFieldByLabel(facetName, facetLabels) || facetName;
    const finalKey = labelKey || facetName;
    // Only process if this facet matches our target
    if (targetFacetName !== finalKey) {
        return [];
    }
    return formatFacetValues(finalKey, facetValues, existingResults);
};
/**
 * Parses a facet string into name and values
 * @param {string} facet - Single facet string
 * @return {Object|null} Object with facetName and facetValues, or null if invalid
 */ const parseFacetString = (facet)=>{
    var ref;
    const [facetName, facetValueRaw] = (ref = facet === null || facet === void 0 ? void 0 : facet.split(":")) !== null && ref !== void 0 ? ref : [];
    if (!facetName || !facetValueRaw) {
        return null;
    }
    // Split values by unescaped pipe and clean up
    const facetValues = facetValueRaw === null || facetValueRaw === void 0 ? void 0 : facetValueRaw.split(_constants_regex__WEBPACK_IMPORTED_MODULE_7__/* .PIPE_NOT_PRECEDED_BY_BACKSLASH_REGEX */ .iD).map((v)=>v.trim().replaceAll(String.raw(_templateObject2()), "|"));
    return {
        facetName,
        facetValues
    };
};
/**
 * Formats facet values into the required string format
 * @param {string} finalKey - The final facet key to use
 * @param {string[]} facetValues - Array of facet values
 * @param {string[]} existingResults - Already processed results to avoid duplicates
 * @return {string[]} Array of formatted facet values
 */ const formatFacetValues = (finalKey, facetValues, existingResults)=>{
    const results = [];
    for (const singleValue of facetValues){
        const formatted = "".concat(finalKey, " - ").concat(singleValue);
        if (!existingResults.includes(formatted)) {
            results.push(formatted);
        }
    }
    return results;
};
/**
 * Formats an array of facet strings into a grouped and delimited string for analytics or API usage.
 * Groups values by their facet label and outputs as "Label:Value1|Value2,...".
 * @param {string[]} inputArray - Array of facet strings in the format "Facet - Value".
 * @param {Object} labels - An object mapping facet field keys to their display labels.
 * @param {string} attributeName - The facet name to prioritize in sorting.
 * @param {string} attributeValue - The facet value to prioritize in sorting.
 * @return {string} The formatted string, e.g., "Collections:Antilia|Beauxline,Material:Cast Iron".
 */ function formatFacets(inputArray, labels, attributeName, attributeValue) {
    const grouped = {};
    // Sort inputArray to prioritize the matching attribute
    const sortedArray = [
        ...inputArray
    ].sort((a, b)=>{
        const [keyA, valueA] = a.split(" - ");
        const [keyB, valueB] = b.split(" - ");
        const isMatchA = keyA === attributeName && valueA === attributeValue;
        const isMatchB = keyB === attributeName && valueB === attributeValue;
        if (isMatchA && !isMatchB) return -1;
        if (!isMatchA && isMatchB) return 1;
        return 0;
    });
    sortedArray.forEach((item)=>{
        let [key, value] = item.split(" - ");
        // Escape pipe characters in value
        if (String(value).includes("|")) {
            value = "".concat(value.replace(/\|/g, "\\|"));
        }
        const label = labels[key] || key;
        if (label) {
            const formattedLabel = label.replace(/\s+/g, "_");
            if (!grouped[formattedLabel]) {
                grouped[formattedLabel] = [];
            }
            grouped[formattedLabel].push(value);
        }
    });
    return Object.entries(grouped).map((param)=>{
        let [label, values] = param;
        return "".concat(label, ":").concat(values.join("|"));
    }).join(",");
}
// facets is an object with facet names as keys and arrays of values as values
// facetLabels is an object with facet names as keys and their display labels as values
const getUniversalUrl = ()=>{
    const isClient = "object" !== "undefined";
    if (isClient) {
        return {
            fullUrl: window.location.href
        };
    }
};
/**
 * Create desktop-only focus/blur handlers for the filter panel.
 * @param {boolean} isMobileViewport - true when viewport is mobile; handlers are no-ops on mobile.
 * @return {Object} An object containing optional `onFocus` and `onBlur` handlers.
 */ const createDesktopScrollHandlers = (isMobileViewport)=>{
    if (isMobileViewport) return {};
    return {
        onFocus: ()=>{
            const filterPanel = document.querySelector(".kohler-scrollarea-viewport");
            if (filterPanel) {
                filterPanel.style.paddingBottom = "90px";
                try {
                    filterPanel.scrollTo({
                        top: filterPanel.scrollHeight - filterPanel.clientHeight,
                        behavior: "smooth"
                    });
                } catch (e) {
                    filterPanel.scrollTop = filterPanel.scrollHeight - filterPanel.clientHeight;
                }
            }
        },
        onBlur: ()=>{
            const filterPanel = document.querySelector(".kohler-scrollarea-viewport");
            if (filterPanel) {
                filterPanel.style.paddingBottom = "";
            }
        }
    };
};
const prepareShareIconObjectFilter = (plpLocalState, t, linkCopied, setLinkCopied, isMobileViewport, isShareCTA)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { twitter: { map: { redirectUrl: twitterRedirectUrl  } = {}  } = {} , facebook: { map: { redirectUrl: facebookRedirectUrl  } = {}  } = {} , linkedin: { map: { redirectUrl: linkedinRedirectUrl  } = {}  } = {}  } = plpLocalState;
    const handlers = createDesktopScrollHandlers(isMobileViewport);
    return {
        sharePopover: {
            withinPortal: false,
            ...handlers.onFocus && {
                onFocus: handlers.onFocus
            },
            ...handlers.onBlur && {
                onBlur: handlers.onBlur
            },
            links: [
                {
                    logo: "facebook",
                    tabIndex: isShareCTA ? 0 : -1,
                    "aria-hidden": !isShareCTA,
                    href: "".concat(facebookRedirectUrl).concat((ref = getUniversalUrl()) === null || ref === void 0 ? void 0 : ref.fullUrl),
                    "data-social-share": "facebook",
                    trackingAttributes: (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getAnalyticsDataForSocialShare */ .mT)(false, "facebook", "".concat(facebookRedirectUrl).concat((ref1 = getUniversalUrl()) === null || ref1 === void 0 ? void 0 : ref1.fullUrl), "share")
                },
                {
                    logo: "twitter",
                    tabIndex: isShareCTA ? 0 : -1,
                    "aria-hidden": !isShareCTA,
                    href: "".concat(twitterRedirectUrl).concat((ref2 = getUniversalUrl()) === null || ref2 === void 0 ? void 0 : ref2.fullUrl),
                    "data-social-share": "twitter",
                    trackingAttributes: (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getAnalyticsDataForSocialShare */ .mT)(false, "twitter", "".concat(twitterRedirectUrl).concat((ref3 = getUniversalUrl()) === null || ref3 === void 0 ? void 0 : ref3.fullUrl), "share")
                },
                {
                    logo: "linkedin",
                    tabIndex: isShareCTA ? 0 : -1,
                    "aria-hidden": !isShareCTA,
                    href: "".concat(linkedinRedirectUrl).concat((ref4 = getUniversalUrl()) === null || ref4 === void 0 ? void 0 : ref4.fullUrl),
                    "data-social-share": "linkedin",
                    trackingAttributes: (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getAnalyticsDataForSocialShare */ .mT)(false, "linkedin", "".concat(linkedinRedirectUrl).concat((ref5 = getUniversalUrl()) === null || ref5 === void 0 ? void 0 : ref5.fullUrl), "share")
                }
            ],
            copyCTA: {
                label: !linkCopied ? t("kf.share.label.copyLink") : t("kf.share.label.copyLinkIndication"),
                tabIndex: isShareCTA ? 0 : -1,
                "aria-hidden": !isShareCTA,
                onClick: (e)=>{
                    var ref, ref1;
                    setLinkCopied(true);
                    // Set timer for 3 seconds to reset linkCopied state
                    setTimeout(()=>{
                        setLinkCopied(false);
                    }, 3000);
                    navigator.clipboard.writeText("".concat((ref = getUniversalUrl()) === null || ref === void 0 ? void 0 : ref.fullUrl));
                    (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getAnalyticsDataForSocialShare */ .mT)(true, t("kf.share.label.copyLink"), "".concat((ref1 = getUniversalUrl()) === null || ref1 === void 0 ? void 0 : ref1.fullUrl));
                }
            },
            emailCTA: {
                label: t("kf.share.label.email"),
                tabIndex: isShareCTA ? 0 : -1,
                "aria-hidden": !isShareCTA,
                onClick: ()=>{
                    var ref;
                    const subject = encodeURIComponent("Check out this product page");
                    const body = encodeURIComponent("".concat((ref = getUniversalUrl()) === null || ref === void 0 ? void 0 : ref.fullUrl));
                    window.location.href = "mailto:?subject=".concat(subject, "&body=").concat(body);
                    (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getAnalyticsDataForSocialShare */ .mT)(true, t("kf.share.label.email"), "n/a");
                }
            },
            showDivider: true
        }
    };
};
/**
 * Formats and returns the props object for PLP filter UI, including analytics handlers and filter logic.
 * @param {Object} plpLocalState - The local state containing facets, facetLabels, filterQuery, colorLabels, plpTotal, and selectedFilterArray.
 * @param {boolean} isFilterVisible - Whether the filter overlay is currently visible.
 * @param {Function} setIsFilterVisible - Function to toggle filter overlay visibility.
 * @param {Object} componentProps - Additional component props (attributeName, attributevalue, swatchUrl).
 * @param {Object} t - Static text labels (clearAll, viewResults, etc.).
 * @param {Function} handleServerSidedataOnchange - Handler for server-side data changes.
 * @param {Function} handleActiveFiltersChange - Handler for active filter changes.
 * @param {boolean} linkCopied - Indicates if the link has been copied to clipboard.
 * @param {Function} setLinkCopied - Function to set the linkCopied state.
 * @param {Function} refreshFilters - Function to refresh the filters.
 * @param {Function} isFromVisualNav - Function to check if the request is from visual navigation.
 * @param {Function} isFromCheckBoxClickedRef - Function to check if the request is from checkbox click.
 * @param {Function} dispatch - Function to dispatch actions to the Redux store.
 * @param {Function} setFilterQueryState - Function to set the filter query state.
 * @param {Function} setIsFromVisualNav - Function to set the visual navigation state.
 * @param {Function} setPageState - Function to set the page state.
 * @param {boolean} isMobileViewport - Boolean flag indicating if the current viewport is mobile.
 * @param {Function} setAnnounceResultsAfterClear - Function to set the announce state after clearing filters.
 * @param {boolean} isShareCTA - Indicates if the share CTA is currently active.
 * @param {Function} setIsShareCTA - Function to set the share CTA state.
 * @return {Object} The formatted props object for the PLP filter component.
 */ const plpFilterArrayFormatter = (plpLocalState, isFilterVisible, setIsFilterVisible, componentProps, t, handleServerSidedataOnchange, handleActiveFiltersChange, linkCopied, setLinkCopied, refreshFilters, isFromVisualNav, isFromCheckBoxClickedRef, dispatch, setFilterQueryState, setIsFromVisualNav, setPageState, isMobileViewport, setAnnounceResultsAfterClear, isShareCTA, setIsShareCTA)=>{
    const { facets , facetLabels , filterQuery , colorLabels , plpTotal  } = plpLocalState;
    const { attributeName , attributevalue , swatchUrl  } = componentProps;
    if (!facets || Object.keys(facets).length === 0) {
        return {};
    }
    const filterFields = Object === null || Object === void 0 ? void 0 : Object.entries(facets).filter((facet)=>facet[1].length > 0);
    const filterItemsArray = filterFields.map((facet)=>({
            title: isPriceRangeFilter(facet[0]) ? t("kf.plp.label.priceRangeTitle") : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .formatFacetName */ .n4H)(facet[0], null, facetLabels),
            accordionProps: {
                toggleCallback: (isOpen, title)=>{
                    (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .addCollapseAnalytics */ .pc)(isOpen, title.text, "products", "Products");
                    handleServerSidedataOnchange();
                    isFromCheckBoxClickedRef.current = true;
                }
            },
            facetName: facet[0],
            filterItems: {
                variant: getInptfieldsVarient(facet[0].replace(/\*\*/g, "")),
                defaultValues: findAttributeValue(facet, facetLabels, attributeName, attributevalue, filterQuery),
                items: Array.from({
                    length: facet[1].length / 2
                }, (_, i)=>({
                        label: isPriceRangeFilter(facet[0]) ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .formatPriceRange */ .NO1)(facet[1][i * 2], false) : "".concat(facet[1][i * 2]),
                        ...facet[1][i * 2 + 1] && {
                            count: facet[1][i * 2 + 1]
                        },
                        value: "".concat(facet[0].replace(/\*\*/g, ""), " - ").concat(facet[1][i * 2]),
                        ...facet[0].replace(/\*\*/g, "") === facetFieldsColor && {
                            image: {
                                src: "".concat(swatchUrl).concat(colorLabels[facet[1][i * 2]], "?$PLPSwatch_Desk100$"),
                                alt: "".concat(facet[0], " - ").concat(facet[1][i * 2]),
                                reveal: "default",
                                loading: "blank"
                            }
                        }
                    }))
            }
        }));
    const propsFilters = {
        filterItemsGroups: [
            ...filterItemsArray.toSorted((a, b)=>{
                if (a.facetName === "Price_Range") return -1;
                if (b.facetName === "Price_Range") return 1;
                return 0;
            })
        ],
        refreshFilters: isFromVisualNav && refreshFilters,
        closeCTA: {
            onClick: ()=>{
                setIsFilterVisible(false);
                (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getAnalyticsDataForFilterCloseOverlay */ .N4)();
            }
        },
        onActiveFiltersChange: (e)=>{
            handleActiveFiltersChange(e);
        },
        onMouseOver: (e)=>{
            handleServerSidedataOnchange();
        },
        tagFilterProps: {
            clearCTA: {
                onClick: (e)=>{
                    isFromCheckBoxClickedRef.current = false;
                    const selectedFilters = (plpLocalState === null || plpLocalState === void 0 ? void 0 : plpLocalState.selectedFilterArray) || [];
                    if (selectedFilters.length === 0) return; // Use the last filter as the one being removed
                    const lastTag = selectedFilters[selectedFilters.length - 1];
                    const [facet, value] = lastTag.split(" - ");
                    const filterArray = selectedFilters.map((item)=>{
                        const [facet, value] = item.split(" - ");
                        return "".concat(isPriceRangeFilter(facet) ? t("kf.plp.label.priceRangeTitle") : facetLabels[facet], ":").concat(isPriceRangeFilter(facet) ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .formatPriceRange */ .NO1)(value) : value);
                    }).join("|");
                    (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getFilterAnalyticsForTagClearCTA */ .ow)(filterArray, isPriceRangeFilter(facet) ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .formatPriceRange */ .NO1)(value) : value, isPriceRangeFilter(facet) ? t("kf.plp.label.priceRangeTitle") : facetLabels[facet]);
                }
            }
        },
        isOverlayOpen: isFilterVisible,
        clearAllCTA: {
            text: t("kf.plp.label.clearAll"),
            onClick: ()=>{
                isFromCheckBoxClickedRef.current = false;
                (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getAnalyticsDataForClearAll */ .Iy)();
                setPageState("clearAll");
                dispatch(setFilterQueryState("NONE"));
                dispatch(setIsFromVisualNav(false));
                // Announce to screen readers that filters were cleared
                try {
                    (0,_utils_announceForAccessibility__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(t("kf.plp.announce.clearAllSuccess") || "Cleared all filters successfully", ()=>{
                        setAnnounceResultsAfterClear(true);
                    });
                } catch (e) {
                /* ignore */ }
            },
            trackingAttributes: {
                "data-datalayer-id": "kds-element-plp-filters-clearAll",
                "data-gbh-data-layer": (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getTrackingAttributeForClearAllCTA */ .l5)()
            }
        },
        shareCTA: {
            label: t("kf.plp.label.share"),
            onClick: ()=>{
                setIsShareCTA(!isShareCTA);
                (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .addPrintOrShareAnalytics */ .A3)("share", "Products", "products");
            }
        },
        ...prepareShareIconObjectFilter(plpLocalState, t, linkCopied, setLinkCopied, isMobileViewport, isShareCTA),
        CTAViewResult: {
            text: "".concat(t("kf.plp.label.viewResults"), " (").concat(plpTotal, ")"),
            onClick: ()=>{
                setIsFilterVisible(!isFilterVisible);
                (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getAnalyticsDataForViewAllResultsCTA */ .og)();
            }
        },
        printCTA: {
            label: t("kf.plp.label.print"),
            onClick: ()=>{
                window.print();
                (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .addPrintOrShareAnalytics */ .A3)("print", "Products", "products");
            },
            ...createDesktopScrollHandlers(isMobileViewport)
        }
    };
    return propsFilters;
};
const getFilterLabel = (isFilterVisible, t, isMobileViewport)=>{
    if (isFilterVisible) {
        return t("kf.plp.label.hideFilter");
    }
    if (isMobileViewport) {
        return t("kf.plp.label.filterSort");
    }
    return t("kf.plp.label.showFilter");
};
const plpSortArrayFormatter = (plpLocalState, t, isFilterVisible, setIsFilterVisible, selectSort, isGrouped, setPlpLocalState, isMobileViewport, dispatch, setServerData)=>{
    const propsSortUI = {
        variant: "default",
        resultsCount: "".concat(plpLocalState.plpTotal, " ").concat(t("kf.plp.label.results")),
        filtersCTA: {
            label: getFilterLabel(isFilterVisible, t, isMobileViewport),
            onClick: ()=>{
                setIsFilterVisible(!isFilterVisible);
                (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getShowHideFilterOptionAnalyticsData */ .ND)(!isFilterVisible);
                (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .removeMavenoidChat */ .N9B)();
            }
        },
        sortDropdownProps: {
            defaultValue: selectSort,
            options: [
                {
                    label: t("kf.plp.label.featured"),
                    value: "featured",
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-plp-sort",
                        "data-gbh-data-layer": (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getTrackingAttributesForSort */ .XN)(t("kf.plp.label.featured"))
                    }
                },
                {
                    label: t("kf.plp.label.priceDesc"),
                    value: "price desc",
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-plp-sort",
                        "data-gbh-data-layer": (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getTrackingAttributesForSort */ .XN)(t("kf.plp.label.priceDesc"))
                    }
                },
                {
                    label: t("kf.plp.label.priceAsc"),
                    value: "price asc",
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-plp-sort",
                        "data-gbh-data-layer": (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getTrackingAttributesForSort */ .XN)(t("kf.plp.label.priceAsc"))
                    }
                },
                {
                    label: t("kf.plp.label.atoz"),
                    value: "".concat(isGrouped ? "CollapseSort_s asc" : "NonCollapseSort_s asc"),
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-plp-sort",
                        "data-gbh-data-layer": (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getTrackingAttributesForSort */ .XN)(t("kf.plp.label.atoz"))
                    }
                },
                {
                    label: t("kf.plp.label.ztoa"),
                    value: "".concat(isGrouped ? "CollapseSort_s desc" : "NonCollapseSort_s desc"),
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-plp-sort",
                        "data-gbh-data-layer": (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getTrackingAttributesForSort */ .XN)(t("kf.plp.label.ztoa"))
                    }
                }
            ],
            onSelect: (e)=>{
                var ref;
                setPlpLocalState((prev)=>({
                        ...prev,
                        selectSort: e
                    }));
                dispatch(setServerData(false));
                (0,_components_ProductList_v3_analytics_PLPFilterAnalytics__WEBPACK_IMPORTED_MODULE_6__/* .getAnalyticsDataForSortByClick */ .mv)((ref = propsSortUI.sortDropdownProps.options.find((sortOption)=>sortOption.value === e)) === null || ref === void 0 ? void 0 : ref.label);
            },
            placeholder: t("kf.plp.label.sort")
        }
    };
    return propsSortUI;
};
const formatPrice = (price, currencySign)=>{
    if (!price || isNaN(price) || price <= 0) return null;
    const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true
    });
    return "".concat(currencySign).concat(formatter.format(Number(price)));
};
const calculateProductPricing = function() {
    let propsProductCard = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, persona = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", general = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, currencySign = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "$", isServerData = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "true";
    const { product: { originalData ={}  } , isGrouped =false , isSterling =false , sterlingData =[]  } = propsProductCard;
    const isCanadaCheck = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .isCanadaSite */ .guj)(general === null || general === void 0 ? void 0 : general.siteName);
    // Helper function to format price range
    const formatPriceRange = (minPrice, maxPrice)=>{
        const formattedMin = formatPrice(minPrice, currencySign);
        const formattedMax = formatPrice(maxPrice, currencySign);
        if (!formattedMin) return null;
        if (!formattedMax || minPrice === maxPrice) return formattedMin;
        return "".concat(formattedMin, " - ").concat(formattedMax);
    };
    // Extract base pricing from product data
    let discountedPrice = originalData["priceList.".concat(persona, ".finalPrice_d")] || 0;
    let finalPrice = originalData["priceList.".concat(persona, ".price_d")] || 0;
    const skuVariantPrice = originalData["Color.".concat(persona, ".Details_ss")] || [];
    let maxPrice = 0;
    let discountedMaxPrice = 0;
    // Handle grouped originalData pricing
    if (isGrouped && !isServerData) {
        finalPrice = originalData.min_price || 0;
        maxPrice = originalData.max_price || 0;
        discountedPrice = originalData.disc_min_price || 0;
        discountedMaxPrice = originalData.disc_max_price || 0;
        if (isCanadaCheck) {
            finalPrice = originalData.min_price || 0;
            maxPrice = originalData.max_price || 0;
        }
    }
    if (isGrouped && isServerData) {
        discountedPrice = originalData["priceList.".concat(persona, ".discMinPrice_d")] || 0;
        discountedMaxPrice = originalData["priceList.".concat(persona, ".discMaxPrice_d")] || 0;
        finalPrice = originalData["priceList.".concat(persona, ".minPrice_d")] || 0;
        maxPrice = originalData["priceList.".concat(persona, ".maxPrice_d")] || 0;
        if (isCanadaCheck) {
            finalPrice = originalData["priceList.".concat(persona, ".minPrice_d")] || 0;
            maxPrice = originalData["priceList.".concat(persona, ".maxPrice_d")] || 0;
        }
    }
    // Handle Sterling originalData pricing override
    if (isSterling && sterlingData.length > 0) {
        var ref;
        const sterlingPrice = (ref = sterlingData[0]) === null || ref === void 0 ? void 0 : ref["priceList.".concat(persona, ".finalPrice_d")];
        if (sterlingPrice) {
            finalPrice = sterlingPrice;
            discountedPrice = sterlingPrice;
        }
    }
    // Check if commerce is disabled
    const isCommerceDisabled = general === null || general === void 0 ? void 0 : general.disableCommerce;
    // When commerce is disabled, modify the pricing logic
    if (isCommerceDisabled) {
        // When commerce is disabled, always use regular prices (finalPrice)
        // and never show discounted prices
        // Determine if there's a price range (using regular prices only)
        let hasPriceRange = false;
        if (isGrouped) {
            hasPriceRange = finalPrice !== maxPrice;
        }
        // Calculate display price using only regular prices
        let displayPrice = null;
        if (finalPrice > 0) {
            if (isGrouped) {
                displayPrice = formatPriceRange(finalPrice, maxPrice);
            } else {
                displayPrice = formatPrice(finalPrice, currencySign);
            }
        }
        return {
            displayPrice,
            slashedPrice: null,
            hasPriceRange,
            skuVariantPrice
        };
    }
    // Original commerce-enabled logic
    // Determine if there's a valid discount
    const hasDiscount = !isCommerceDisabled && discountedPrice > 0 && discountedPrice !== finalPrice;
    // Determine if there's a price range
    let hasPriceRange1 = false;
    if (isGrouped) {
        if (hasDiscount) {
            hasPriceRange1 = discountedPrice !== discountedMaxPrice;
        } else {
            hasPriceRange1 = finalPrice !== maxPrice;
        }
    }
    // Calculate display price
    let displayPrice1 = null;
    if (finalPrice > 0) {
        if (isGrouped) {
            const minDisplayPrice = hasDiscount ? discountedPrice : finalPrice;
            const maxDisplayPrice = hasDiscount ? discountedMaxPrice : maxPrice;
            displayPrice1 = formatPriceRange(minDisplayPrice, maxDisplayPrice);
        } else {
            const singleDisplayPrice = hasDiscount ? discountedPrice : finalPrice;
            displayPrice1 = formatPrice(singleDisplayPrice, currencySign);
        }
    }
    // Calculate slashed price (original price when on discount)
    let slashedPrice = null;
    if (hasDiscount && finalPrice > 0) {
        if (isGrouped) {
            slashedPrice = formatPriceRange(finalPrice, maxPrice);
        } else {
            slashedPrice = formatPrice(finalPrice, currencySign);
        }
    }
    return {
        displayPrice: displayPrice1,
        slashedPrice,
        hasPriceRange: hasPriceRange1,
        skuVariantPrice
    };
};


/***/ }),

/***/ 67318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ announceForAccessibility; }
/* harmony export */ });
/* eslint-disable require-jsdoc */ function announceForAccessibility(message, callBack) {
    if (typeof document === "undefined") return;
    const el = document.getElementById("site-announcer");
    if (el) {
        el.textContent = message;
        // Clear it after a short time so same message can be re-announced later
        setTimeout(()=>{
            callBack && callBack();
        }, 4000);
    }
}


/***/ })

}]);